<template>
  <main class="w-100">
    <modal name="aiscript" class="modal-preview p-4" :resizable="true" height="auto" width="80%" :scrollable="true"
      :max-width="400" style="z-index: 10">


      <div v-if="oppLoading" class="text-center">
          <span class="loadingres spinner-border loading-spinner"></span>
          <br />
          Loading opportunity...
          
      </div>
      <!--  Cabezera -->
      <div v-if="!oppLoading">
        <div class="p-4 my-4 text-center text-secondary">
           <div class="row" v-if="pushButton">
              <div class="col-md-8 text-left">
                <div class="d-flex flex-row">
                  <img :src="existAvatarEnterprice" alt="" class="mr-3 headerModalImg" />
                  <div>
                    <span>{{ $t("lang.label.represented_for") }} :</span>
                    <h4 class="font-weight-bold m-0">
                      {{ opportunity.link.c_name }}
                    </h4>
                    <small class="text-primary"><a :href="opportunity.link.website" target="_blank">{{
                      opportunity.link.website
                    }}</a></small>
                    <div></div>
                  </div>
                  <span>
                    <small class="font-weight-bold">
                      {{
                         opportunity.link.short_description
                        
                      }}
                    </small>
                    <button v-if="
                      opportunity.link.short_description != null &&
                      opportunity.link.short_description.length > limit
                    " @click="toggleExpand()" :class="showMore
                          ? 'btn btn-danger ml-2 py-0 px-2'
                          : 'btn btn-primary ml-2 py-0 px-2'
                        ">
                      <i :class="showMore ? 'icon-minus' : 'icon-plus'"></i>
                    </button>
                  </span>
                </div>
              </div>
              <!-- <div v-if="prospector" class="col-md-4 d-flex justify-content-end">
                <div class="px-5 text-left">
                  <span>{{ $t("lang.label.email_send_for") }} :</span>
                  <h5 class="font-weight-bold m-0">
                    {{ prospector.label_from }}
                  </h5>
                  <small>{{ prospector.email }}</small>
                </div>
              </div> -->
            </div>
          <hr />

          <ColdCallPrepBar v-if="pushButton" :script="coldCall" />

          <!-- 📌 Menú de Opciones -->
          <div class="row py-3 mt-3" v-if="pushButton">
            <div class="col-3">
              <div class="my-2">
                <select :key="refreshButtonAI" v-model="selectedBusinessContact" @change="getSpeach(false)"
                  class="form-control">
                  <option v-for="status in opportunity.business_contacts" :key="status.id" :value="status">
                    {{ status.name }} ( {{ status.email }})
                  </option>
                </select>
                <div class="w-100 text-center p-2 mt-3" v-if="selectedBusinessContact">
                  <!-- <img :src="opportunity.business.avatar ? opportunity.business.avatar : '@/assets/images/emptyperson.png'" alt="contact" class="rounded-circle headerModalImg" /> -->
                  <img src="@/assets/images/emptyperson.png" width="80px" alt="contact"
                      class="rounded-circle mb-2 headerModalImg" />
                  <strong>
                    <h5 class="mb-1">{{ selectedBusinessContact.name }}</h5>
                  </strong>
                  <div class="mb-2">
                    <small>
                      <h6 class="m-0">
                        {{ selectedBusinessContact.job }}
                      </h6>
                    </small>
                    <div class="mb-1">
                      <span>
                        <h6 class="m-0">
                          {{ opportunity.business.name }}
                        </h6>
                      </span>
                    </div>
                    <div class="d-flex flex-row justify-content-center">
                      <img v-if="opportunity.business.logo" :src="opportunity.business.logo" alt="icon-logo"
                        class="mr-2 rounded bodyModalIcon" />
                      <p>{{ opportunity.business.alias }}</p>
                    </div>
                  </div>
                  <div>
                    <button v-if="selectedBusinessContact.phone" class="btn btn-success px-4 mb-3" @click="call()">
                      <small><i class="icon-phone"></i>
                        {{ selectedBusinessContact.phone }}</small>
                      <br />{{ $t("lang.task.start_call") }}
                    </button>
                    <div v-if="hasPhones">
                      <button v-for="(phone, index) in phoneList" :key="index" class="btn btn-success px-4 mb-3"
                        @click="call(phone)">
                        <small><i class="icon-phone"></i>
                          {{ phone.trim() }}</small><br />
                        {{ $t("lang.task.start_call") }}
                      </button>
                    </div>

                    <!-- <span v-if="
                      !selectedBusinessContact.event_phone &&
                      !selectedBusinessContact.phone
                    " class="text-danger">
                      <button @click="findPhoneNumber(selectedBusinessContact)" class="btn btn-sm btn-primary">
                        {{
                          loadingPhone
                            ? "Searching...Please wait"
                            : "Find phone number"
                        }}
                      </button>
                    </span> -->
                  </div>
                </div>
                <hr class="m-0" />
              </div>
              <div class="card">
                <div class="list-group cc-scroll text-left" style="max-height: 520px">
                  <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 99"
                    :class="answersIndex == 99 ? 'active' : ''">
                    Main Script
                     <span v-if="this.openAiAnswers[0].loading"
                      class="loadingres spinner-border loading-spinner ml-2"></span>
                  </a>
                  <template v-if="ccObjections.length">
                    <div class="list-group-item cc-section-title py-1">{{ $t("lang.label.cold_call_script.objections_section") }}</div>
                    <a v-for="(objection, i) in ccObjections" :key="'cc-objection-' + i" href="#"
                      class="list-group-item list-group-item-action" :title="objection.titre"
                      :class="answersIndex == ccObjectionIndex(i) ? 'active' : ''"
                      @click.prevent="answersIndex = ccObjectionIndex(i)">
                      <span class="cc-objection-label">{{ objection.titre }}</span>
                    </a>
                    <div class="list-group-item cc-section-title py-1">{{ $t("lang.label.cold_call_script.general_section") }}</div>
                  </template>
                  <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 0"
                    :class="answersIndex == 0 ? 'active' : ''">
                    Je ne suis pas intéréssé
                    <span v-if="this.openAiAnswers[1].loading"
                      class="loadingres spinner-border loading-spinner ml-2"></span>
                  </a>
                  <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 1"
                    :class="answersIndex == 1 ? 'active' : ''">
                    Envoyez-moi un e-mail
                    <span v-if="this.openAiAnswers[2].loading"
                      class="loadingres spinner-border loading-spinner ml-2"></span>
                  </a>
                  <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 2"
                    :class="answersIndex == 2 ? 'active' : ''">
                    Numéro de téléphone ?
                    <span v-if="this.openAiAnswers[3].loading"
                      class="loadingres spinner-border loading-spinner ml-2"></span>
                  </a>
                  <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 3"
                    :class="answersIndex == 3 ? 'active' : ''">
                    Je rentre en réunion
                    <span v-if="this.openAiAnswers[4].loading"
                      class="loadingres spinner-border loading-spinner ml-2"></span>
                  </a>
                  <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 4"
                    :class="answersIndex == 4 ? 'active' : ''">
                    Nous faisons cela en interne
                    <span v-if="this.openAiAnswers[5].loading"
                      class="loadingres spinner-border loading-spinner ml-2"></span>
                  </a>
                  <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 5"
                    :class="answersIndex == 5 ? 'active' : ''">
                    Je ne suis pas la bonne personne
                    <span v-if="this.openAiAnswers[6].loading"
                      class="loadingres spinner-border loading-spinner ml-2"></span>
                  </a>
                  <!-- <a href="#" class="list-group-item list-group-item-action"
                    @click="answersIndex = 6"
                    :class="answersIndex == 6 ? 'active' : ''">
                    Calendar
                  </a> -->
                </div>
              </div>
            </div>

            <!-- 📌 Texto del Script -->
              <div class="col-5 cc-col">
                <ColdCallConsignes v-if="pushButton" :text="coldCall && coldCall.cc_consignes" />
                <div class="card p-3 cc-scroll" ref="ccScriptCard" style="max-height: 560px">
                  <ColdCallObjection v-if="ccSelectedObjection" :objection="ccSelectedObjection" />
                  <div v-else-if="!checkLoading() && !loadingSpeach && ccShowPitchFallback(getOpenAiResult())" class="text-left">
                    <p class="cc-text font-weight-bold mb-2" style="color: #fd7e14">{{ $t("lang.label.cold_call_script.pitch_fallback") }}</p>
                    <p class="cc-text">{{ ccPitch }}</p>
                  </div>
                  <div v-else-if="answersIndex != 6 && !checkLoading() && !loadingSpeach">
                    <pre> {{ getOpenAiResult() }}</pre>
                  </div>
                  <div class="w-50 p-2 m-2" v-else>
                    <span class="loadingres spinner-border loading-spinner ml-2"></span>
                  </div>

                  <div
                    v-if="
                      currentUser.role_id == 1 &&
                      answersIndex != 6 &&
                      !ccSelectedObjection &&
                      !checkLoading() &&
                      !loadingSpeach &&
                      selectedBusinessContact
                    "
                    class="d-flex flex-wrap mt-2"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary mr-2 mb-1"
                      @click="inspectCallPrompt()"
                    >
                      {{ $t('lang.label.inspect_call_prompt') }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary mb-1"
                      :disabled="loadingRegenerateCallScript"
                      @click="regenerateCallScript()"
                    >
                      <span
                        v-if="loadingRegenerateCallScript"
                        class="loadingres spinner-border loading-spinner spinner-border-sm mr-1"
                      ></span>
                      {{ $t('lang.label.regenerate_call_script') }}
                    </button>
                  </div>

                  <strong
                    v-if="
                      !checkLoading &&
                      !getOpenAiPrompt() &&
                      opportunity.link.userBilling
                    "
                    class="text-danger"
                    ><i class="icon icon-warning"></i> The prompt for
                    opportunities in
                    {{  getLanguage(opportunity.link.userBilling.language_id) }}
                    language has not yet been configured. Please inform the
                    person in charge of this.</strong>
                </div>
              </div>

            <!-- 📌 Calendario -->
            <div class="col-4">
              <div class="card p-3">
                <div v-if="!checkCalendly()">
                  <EmbedCalendar v-if="opportunity.link.user_id" :currentBusinessContact="currentBusinessContact"
                    :lastHumanResponse="opportunity.last_human_response"
                    :businessName="opportunity.business.name" :user_id="opportunity.link.user_id"
                    :link_hash="getLinkId()" />
                </div>

                <div v-if="checkCalendly()">
                  <iframe :src="opportunity.campaignTokens.my_calendar_link.value" frameborder="0"
                    style="width: 100%; height: 1000px"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </modal>

    <modal
      name="callPromptInspectModal"
      class="modal-preview p-3"
      :resizable="true"
      height="auto"
      width="92%"
      :scrollable="true"
      :max-width="1400"
      style="z-index: 20"
    >
      <div class="p-3 text-left">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">{{ $t('lang.label.inspect_call_prompt_title') }}</h5>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="$modal.hide('callPromptInspectModal')"
          >
            {{ $t('lang.button.close') }}
          </button>
        </div>

        <div v-if="loadingCallPromptInspect" class="text-center py-5">
          <span class="loadingres spinner-border loading-spinner"></span>
        </div>

        <div v-else-if="callPromptInspect">
          <p class="small mb-3">
            <strong>{{ $t('lang.label.inspect_call_prompt_template') }}:</strong>
            <code>{{ callPromptInspect.template_key }}</code>
            <span class="text-muted ml-2">({{ callPromptInspect.provider }} / {{ callPromptInspect.model }})</span>
          </p>

          <div v-if="callPromptInspectShortcodes.length" class="mb-4">
            <strong class="small d-block mb-2">{{ $t('lang.label.inspect_call_prompt_shortcodes') }}</strong>
            <div class="table-responsive">
              <table class="table table-sm table-bordered mb-0">
                <tbody>
                  <tr v-for="entry in callPromptInspectShortcodes" :key="entry.token">
                    <td class="font-weight-bold text-nowrap align-top" style="width: 22%">{{ entry.token }}</td>
                    <td style="white-space: pre-wrap; font-size: 12px">{{ entry.value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <strong class="small d-block mb-2">{{ $t('lang.label.inspect_call_prompt_template_raw') }}</strong>
              <pre class="small border rounded p-3 mb-0 bg-light" style="max-height: 420px; overflow: auto">{{ callPromptInspect.template_raw }}</pre>
            </div>
            <div class="col-md-6 mb-3">
              <strong class="small d-block mb-2">{{ $t('lang.label.inspect_call_prompt_resolved') }}</strong>
              <pre class="small border rounded p-3 mb-0 bg-light" style="max-height: 420px; overflow: auto">{{ callPromptInspect.prompt_resolved }}</pre>
            </div>
          </div>
        </div>

        <p v-else class="text-danger mb-0">{{ callPromptInspectError || $t('lang.general.error') }}</p>
      </div>
    </modal>

    <LoadingSpinner v-if="!completeLoading" />
    <div v-else class="bdr-tasks-page">
      <div class="bdr-tasks-head">
        <div class="bdr-tasks-head__icon" aria-hidden="true">
          <i class="icon-check1"></i>
        </div>
        <div>
          <h4 class="bdr-tasks-head__title">Bookers Calls / Tasks</h4>
          <p class="bdr-tasks-head__subtitle">
            Tâches :
            <small v-if="!total" class="bdr-tasks-head__calculating">Calcul en cours…</small>
            <strong v-else>{{ total }}</strong>
            <span class="bdr-tasks-head__sep">·</span>
            Actions :
            <small v-if="!total_actions" class="bdr-tasks-head__calculating">Calcul en cours…</small>
            <strong v-else>{{ total_actions }}</strong>
          </p>
        </div>
      </div>

      <div class="col-12 px-0" v-if="withIputRange">
        <div class="bdr-tasks-filters">
          <div class="row bdr-tasks-filters__row">
            <div class="col-lg-6 col-md-12 bdr-tasks-filters__cell">
              <label class="bdr-tasks-filters__label">Période</label>
              <div class="bdr-tasks-filters__date-range">
                <i class="icon-calendar bdr-tasks-filters__date-icon" aria-hidden="true"></i>
                <date-picker
                  id="startDatePicker"
                  class="bdr-tasks-filters__date-input"
                  v-model="filters.range.startDate"
                  :config="datePickerConfig"
                  placeholder="Date début"
                ></date-picker>
                <span class="bdr-tasks-filters__date-sep">→</span>
                <date-picker
                  id="endDatePicker"
                  class="bdr-tasks-filters__date-input"
                  v-model="filters.range.endDate"
                  :config="datePickerConfigEndDate"
                  placeholder="Date fin"
                ></date-picker>
              </div>
            </div>
            <div
              class="col-lg-6 col-md-12 bdr-tasks-filters__cell treeselect-wrapper"
              v-if="['1', '9'].includes(currentUser.role_id) || isBookerManager()"
            >
              <label class="bdr-tasks-filters__label">BDR</label>
              <treeselect
                v-model="filters.bdrUserFilter"
                :options="bdrUserOptions"
                :normalizer="normalizeOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="BDR · tous"
              ></treeselect>
            </div>
          </div>

          <div class="row bdr-tasks-filters__row">
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Type de tâche</label>
              <treeselect
                v-model="filters.taskTypeFilter"
                :options="taskTypeOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Type · tous"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">État de la température</label>
              <treeselect
                v-model="filters.temperatureStatusFilter"
                :options="temperatureStatuseOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Température · tous"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Statut des opportunités</label>
              <treeselect
                v-model="filters.oppStatusFilter"
                :options="oppStatusOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Statut · tous"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Réunion prévue</label>
              <treeselect
                v-model="filters.withMeeting"
                :options="withMeetingOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Réunion · tous"
              ></treeselect>
            </div>
          </div>

          <div class="row bdr-tasks-filters__row">
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Clients</label>
              <treeselect
                v-model="filters.client"
                class="bdr-tasks-filters__select"
                :options="filteredClients"
                :multiple="false"
                :searchable="true"
                :clearable="true"
                :loading="isLoading"
                placeholder="Rechercher un client"
                label="label"
                track-by="id"
                @search-change="onSearchChange"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Task Output</label>
              <treeselect
                v-model="filters.taskOutputFilter"
                :options="taskOutputOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Output · tous"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Call Status</label>
              <treeselect
                v-model="filters.callStatusFilter"
                :options="callStatusOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Statut appel · tous"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Call Duration</label>
              <treeselect
                v-model="filters.callDurationFilter"
                :options="callDurationOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Durée · tous"
              ></treeselect>
            </div>
          </div>

          <div class="row bdr-tasks-filters__row">
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Meeting (AI)</label>
              <treeselect
                v-model="filters.meetingAIFilter"
                :options="meetingAIOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Meeting (AI) · tous"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Objection</label>
              <treeselect
                v-model="filters.objectionFilter"
                :options="objectionOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Objection · toutes"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Qualification</label>
              <treeselect
                v-model="filters.qualificationsFilter"
                :options="qualificationsOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Qualification · toutes"
              ></treeselect>
            </div> 
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Contact établi</label>
              <treeselect
                v-model="filters.contactEstablishedFilter"
                :options="contactEstablishedOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="Contact établi · tous"
              ></treeselect>
            </div>
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Booker Type</label>
              <select class="form-control" v-model="filters.booker_type">
                <option value="all">All Types</option>
                <option value="human">Human</option>
                <option value="ai_agent">Agent AI</option>
              </select>
            </div>

            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">Opportunity ID</label>
              <input
                v-model.number="filters.linkIdFilter"
                type="number"
                min="0"
                class="bdr-tasks-filters__select form-control"
                placeholder="Opportunity ID"
              />
            </div>
          </div>

          <div class="row bdr-tasks-filters__row">
            <div class="col-lg-3 col-md-6 bdr-tasks-filters__cell treeselect-wrapper">
              <label class="bdr-tasks-filters__label">AI vs Meeting</label>
              <treeselect
                v-model="filters.meetingAiMismatchFilter"
                :options="meetingAiMismatchOptions"
                :multiple="true"
                class="bdr-tasks-filters__select"
                placeholder="AI vs Meeting · tous"
              ></treeselect>
            </div>
          </div>

          <div class="row bdr-tasks-filters__row bdr-tasks-filters__row--action">
            <div class="col-12 d-flex justify-content-end">
              <button
                type="button"
                class="bdr-tasks-filters__go-btn"
                :disabled="!completeLoading"
                @click="getBdrTaskList()"
              >
                <i class="icon-rocket" aria-hidden="true"></i>
                C'est parti !
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 w-100 mb-3 card p-2">
        <div v-if="completeLoading && total > 0" class="row">
          <div class="col-md-12">
            <div class="bdr-tasks-toolbar">
              <button
                type="button"
                class="bdr-tasks-csv-btn"
                @click="getToDownload()"
                :disabled="processingAllItems"
              >
                <i class="icon-download" aria-hidden="true"></i>
                <span v-if="!processingAllItems">Télécharger CSV</span>
                <span v-else>Traitement…</span>
              </button>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-4 text-left">
                <button
                  v-if="withCheckbox"
                  type="button"
                  class="btn btn-primary btn-sm d-inline-flex align-items-center"
                  :disabled="!selectedTaskIds.length || downloading"
                  @click="downloadSelectedTasks()"
                >
                  <span
                    v-if="downloading"
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    v-else
                    class="icon-download mr-1"
                    aria-hidden="true"
                  ></i>
                  <span v-if="downloading">
                    {{ $t("lang.button.processing") }}
                  </span>
                  <span v-else>
                    {{ $t("lang.button.downloaddata") }}
                  </span>
                  <span
                    v-if="!downloading && selectedTaskIds.length"
                    class="badge badge-light badge-pill ml-2"
                  >
                    {{ selectedTaskIds.length }}
                  </span>
                </button>
                <button
                  v-if="withCheckbox"
                  type="button"
                  class="btn btn-primary btn-sm d-inline-flex align-items-center ml-2"
                  :disabled="!selectedTaskIds.length"
                  @click="analyseClientCalls()"
                >
                  <i
                    class="icon-search mr-1"
                    aria-hidden="true"
                  ></i>
                  <span>
                    {{ $t("lang.button.analyse_calls") }}
                  </span>
                  <span
                    v-if="selectedTaskIds.length"
                    class="badge badge-light badge-pill ml-2"
                  >
                    {{ selectedTaskIds.length }}
                  </span>
                </button>
              </div>
              <div class="col-4 text-center">
                <Pagination :total="total" :totalpage="bdrTaskListQty" :model="pagination" :limit="false"
                  :color="'primary'" @changePage="getBdrTaskList" key="paginationkey"></Pagination>
              </div>
              <div class="col-4"></div>
            </div>
          </div>
        </div>

        <div class="col-md-12 px-0 mx-0">
          <TableV2
            :key="3232323"
            :headers="simpleheader"
            :cols="simplecols"
            :data="list"
            :column-groups="columnGroups"
            :legends="tableLegends"
            :checkbox="withCheckbox"
            checkbox-field="ref_id"
            :notselect="true"
            :model="[]"
            @selection-change="onTasksSelectionChange"
            @goToOpportunity="goToOpportunity"
            @goToAgency="goToAgency"
            @showCall="showCall"
            @showTranscriptions="showTranscriptions"
            @showConversation="showConversation"
            @getOpportunityById="getOpportunity"
            @runVerifier="runVerifier"
            @runMeetingAi="runMeetingAi"
            @runQualificationAi="runQualificationAi"
            @createMeetingFromCall="createMeetingFromCall"
          />
        </div>
      </div>
    </div>
    <Modal :name="'showMail'" :size="'60'" :close="true">
      <div class="bg-custon-gray rounded p-3">
        <div class="row rowborder not-Margin mt-2 mb-1">
          <div class="col-12">
            <div class="">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-default">From:</span>
                </div>
                <input id="input_subject" v-model="email.from" type="text" :disabled="true" class="form-control input-b"
                  aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" />
              </div>
            </div>
          </div>
        </div>
        <div class="row rowborder not-Margin mt-2 mb-1">
          <div class="col-12">
            <div class="">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-default">To:</span>
                </div>
                <input id="input_subject" v-model="email.to" type="text" :disabled="true" class="form-control input-b"
                  aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" />
              </div>
            </div>
          </div>
        </div>
        <div class="row rowborder not-Margin mt-2 mb-1">
          <div class="col-12">
            <div class="">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-default">Subject:</span>
                </div>
                <input id="input_subject" v-model="email.subject" type="text" :disabled="true"
                  class="form-control input-b" aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default" />
              </div>
            </div>
          </div>
        </div>
        <div class="row rowborder not-Margin mt-2 mb-1">
          <div class="col-12">
            <p v-html="email.message"></p>
          </div>
        </div>
      </div>
    </Modal>

    <Modal :name="'showCalls'" :size="'60'" :close="true">
      <div class="px-3">
        <h2>CALLS</h2>
        <div class="card mt-2" v-for="(call, index) in callsToShow" :key="'call-' + index">
          <div class="card-body d-flex justify-content-center align-items-center">
            <span :class="call == 'ANSWERED'
              ? 'badge badge-success'
              : 'badge badge-danger'
              " class="mr-2">{{ call }}</span>
            <div
              v-if="callsRecords[index] || (callsSourceType === 'elevenlabs' && callsConversationId)"
              class="ml-3"
            >
              <template v-if="callsSourceType === 'elevenlabs' && callsConversationId">
                <audio
                  :id="'audio-' + callsConversationId + '-' + index"
                  controls
                  src="data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAA="
                  style="width: 300px; height: 20px;"
                  @play="onElevenLabsPlay(callsConversationId, $event)"
                ></audio>
              </template>
              <template v-else>
                <audio ref="audio" v-if="callsRecords[index]" :src="callsRecords[index]" controls></audio>
              </template>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <Modal :name="'transcription-modal'" :size="'70'" :max-width="'500'" :close="true">
      <div class="px-3" v-for="transcription in transcriptions" :key="2231">

        <div v-html="transcription"></div>

      </div>
    </Modal>
    <Modal name="verifier-preview-modal" :size="'70'" :max-width="'700'" :close="true">
      <div class="p-4">
        <h4 class="mb-3">Verifier analysis comparison</h4>

        <div v-if="verifierPreview.loading" class="text-center my-4">
          <span class="loadingres spinner-border loading-spinner"></span>
          <div class="mt-2">Running Verifier...</div>
        </div>

        <div v-else>
          <div class="row" v-if="verifierPreview.hasTranscription">
            <div class="col-md-6 mb-3">
              <div class="card p-3 h-100">
                <h5>Current result</h5>
                <span
                  class="badge mb-2"
                  :style="getVerifierBadgeStyle(verifierPreview.current.task_fake)"
                >
                  {{ getVerifierLabel(verifierPreview.current.task_fake) }}
                </span>
                <label class="font-weight-bold small">Justification</label>
                <textarea
                  class="form-control"
                  rows="8"
                  readonly
                  :value="verifierPreview.current.justification || '-'"
                ></textarea>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="card p-3 h-100">
                <h5>New result</h5>
                <span
                  class="badge mb-2"
                  :style="getVerifierBadgeStyle(verifierPreview.newResult.task_fake)"
                >
                  {{ getVerifierLabel(verifierPreview.newResult.task_fake) }}
                </span>
                <label class="font-weight-bold small">Justification</label>
                <textarea
                  class="form-control"
                  rows="8"
                  readonly
                  :value="verifierPreview.newResult.justification || '-'"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="row" v-else>
            <div class="col-12 mb-3">
              <div class="card p-3">
                <h5>Current result</h5>
                <span
                  class="badge mb-2"
                  :style="getVerifierBadgeStyle(verifierPreview.current.task_fake)"
                >
                  {{ getVerifierLabel(verifierPreview.current.task_fake) }}
                </span>
                <label class="font-weight-bold small">Justification</label>
                <textarea
                  class="form-control"
                  rows="6"
                  readonly
                  :value="verifierPreview.current.justification || '-'"
                ></textarea>
              </div>
            </div>
          </div>

          <div v-if="verifierPreview.debugVars" class="mt-3">
            <div class="card p-3 border-info">
              <h6 class="text-info mb-2">🔍 Debug — Variables injected</h6>
              <table class="table table-sm table-bordered mb-0">
                <tbody>
                  <tr><td class="font-weight-bold">booker_prenom</td><td>{{ verifierPreview.debugVars.booker_prenom || '(empty)' }}</td></tr>
                  <tr><td class="font-weight-bold">booker_nom</td><td>{{ verifierPreview.debugVars.booker_nom || '(empty)' }}</td></tr>
                  <tr><td class="font-weight-bold">prospect_prenom</td><td>{{ verifierPreview.debugVars.prospect_prenom || '(empty)' }}</td></tr>
                  <tr><td class="font-weight-bold">prospect_nom</td><td>{{ verifierPreview.debugVars.prospect_nom || '(empty)' }}</td></tr>
                  <tr><td class="font-weight-bold">transcript_length</td><td>{{ verifierPreview.debugVars.transcript_length }} chars</td></tr>
                  <tr><td class="font-weight-bold">transcript_preview</td><td style="white-space:pre-wrap;font-size:11px">{{ verifierPreview.debugVars.transcript_preview || '(empty)' }}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="verifierPreview.debugPrompt" class="mt-3">
            <div class="card p-3 border-warning">
              <h6 class="text-warning mb-1">🔍 Debug — Prompt sent to AI (first 400 chars)</h6>
              <textarea class="form-control form-control-sm" rows="4" readonly :value="verifierPreview.debugPrompt"></textarea>
            </div>
          </div>

          <div v-if="isVerifierAdmin" class="card p-3 mt-3">
            <h5 class="mb-3">{{ $t('lang.label.verifier_override_manual') }}</h5>
            <div class="d-flex flex-wrap mb-3">
              <button
                type="button"
                class="btn btn-sm mr-2 mb-1"
                :style="getVerifierOverrideOptionStyle(1)"
                @click="verifierPreview.override.task_fake = 1"
              >
                FAKE
              </button>
              <button
                type="button"
                class="btn btn-sm mr-2 mb-1"
                :style="getVerifierOverrideOptionStyle(2)"
                @click="verifierPreview.override.task_fake = 2"
              >
                ABUSIF
              </button>
              <button
                type="button"
                class="btn btn-sm mb-1"
                :style="getVerifierOverrideOptionStyle(3)"
                @click="verifierPreview.override.task_fake = 3"
              >
                VALIDE
              </button>
            </div>
            <label class="font-weight-bold small">{{ $t('lang.label.verifier_override_motif') }}</label>
            <textarea
              class="form-control mb-3"
              rows="3"
              v-model="verifierPreview.override.motif"
              :placeholder="$t('lang.label.verifier_override_motif')"
            ></textarea>
            <div class="d-flex justify-content-end">
              <Tooltip :text="$t('lang.label.verifier_override_force_tooltip')" :width="'auto'">
                <button
                  class="btn btn-primary"
                  :disabled="!canForceVerifierOverride"
                  @click="confirmVerifierOverride()"
                >
                  <span v-if="!verifierPreview.saving">{{ $t('lang.label.verifier_override_force') }}</span>
                  <span v-else>Saving...</span>
                </button>
              </Tooltip>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="closeVerifierPreviewModal()">
              Cancel
            </button>
            <button
              v-if="isVerifierAdmin && verifierPreview.hasTranscription"
              class="btn btn-success"
              :disabled="!canAcceptVerifierAiResult"
              @click="confirmVerifierUpdate()"
            >
              <span v-if="!verifierPreview.saving">{{ $t('lang.label.verifier_accept_ai_result') }}</span>
              <span v-else>Saving...</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
    <Modal name="meeting-ai-preview-modal" :size="'70'" :max-width="'760'" :close="true">
      <div class="p-4">
        <h4 class="mb-3">Meeting AI analysis comparison</h4>

        <div v-if="meetingAiPreview.loading" class="text-center my-4">
          <span class="loadingres spinner-border loading-spinner"></span>
          <div class="mt-2">Running Meeting AI...</div>
        </div>

        <div v-else>
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="card p-3 h-100">
                <h5>Current result</h5>
                <span class="badge badge-secondary mb-2">
                  {{ meetingAiPreview.current.meeting_status || '-' }}
                </span>
                <label class="font-weight-bold small">Response</label>
                <textarea
                  class="form-control"
                  rows="9"
                  readonly
                  :value="meetingAiPreview.current.response || '-'"
                ></textarea>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="card p-3 h-100">
                <h5>New result</h5>
                <span class="badge badge-primary mb-2">
                  {{ meetingAiPreview.newResult.meeting_status || '-' }}
                </span>
                <label class="font-weight-bold small">Response</label>
                <textarea
                  class="form-control"
                  rows="9"
                  readonly
                  :value="meetingAiPreview.newResult.response || '-'"
                ></textarea>
              </div>
            </div>
          </div>

          <div v-if="meetingAiPreview.debugVars" class="mt-3">
            <div class="card p-3 border-info">
              <h6 class="text-info mb-2">Debug variables</h6>
              <table class="table table-sm table-bordered mb-0">
                <tbody>
                  <tr><td class="font-weight-bold">type</td><td>{{ meetingAiPreview.debugVars.type || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">entity_type</td><td>{{ meetingAiPreview.debugVars.entity_type || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">ref_id</td><td>{{ meetingAiPreview.debugVars.ref_id || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">valid_meeting</td><td>{{ meetingAiPreview.debugVars.valid_meeting || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">transcript_length</td><td>{{ meetingAiPreview.debugVars.transcript_length || 0 }} chars</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="meetingAiPreview.debugPrompt" class="mt-3">
            <div class="card p-3 border-warning">
              <h6 class="text-warning mb-1">Prompt sent to AI</h6>
              <textarea class="form-control form-control-sm" rows="4" readonly :value="meetingAiPreview.debugPrompt"></textarea>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="closeMeetingAiPreviewModal()">
              Cancel
            </button>
            <button
              class="btn btn-success"
              :disabled="meetingAiPreview.saving || !meetingAiPreview.newResult.meeting_status || !meetingAiPreview.newResult.response"
              @click="confirmMeetingAiUpdate()"
            >
              <span v-if="!meetingAiPreview.saving">Update Meeting AI value</span>
              <span v-else>Saving...</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>

    <Modal name="qualification-ai-preview-modal" :size="'70'" :max-width="'760'" :close="true">
      <div class="p-4">
        <h4 class="mb-3">Qualification AI analysis comparison</h4>

        <div v-if="qualificationAiPreview.loading" class="text-center my-4">
          <span class="loadingres spinner-border loading-spinner"></span>
          <div class="mt-2">Running Qualification AI...</div>
        </div>

        <div v-else>
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="card p-3 h-100">
                <h5>Current result</h5>
                <span class="badge badge-secondary mb-2">
                  {{ qualificationAiPreview.current.tag || '-' }}
                </span>
                <label class="font-weight-bold small">Description</label>
                <textarea
                  class="form-control"
                  rows="9"
                  readonly
                  :value="qualificationAiPreview.current.description || '-'"
                ></textarea>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="card p-3 h-100">
                <h5>New result</h5>
                <span class="badge badge-primary mb-2">
                  {{ qualificationAiPreview.newResult.tag || '-' }}
                </span>
                <label class="font-weight-bold small">Description</label>
                <textarea
                  class="form-control"
                  rows="9"
                  readonly
                  :value="qualificationAiPreview.newResult.description || '-'"
                ></textarea>
              </div>
            </div>
          </div>

          <div v-if="qualificationAiPreview.debugVars" class="mt-3">
            <div class="card p-3 border-info">
              <h6 class="text-info mb-2">Debug variables</h6>
              <table class="table table-sm table-bordered mb-0">
                <tbody>
                  <tr><td class="font-weight-bold">notification_id</td><td>{{ qualificationAiPreview.debugVars.notification_id || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">ringover_event_id</td><td>{{ qualificationAiPreview.debugVars.ringover_event_id || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">prospect</td><td>{{ qualificationAiPreview.debugVars.prospect_name || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">prospect_phone</td><td>{{ qualificationAiPreview.debugVars.prospect_phone || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">prospect_email</td><td>{{ qualificationAiPreview.debugVars.prospect_email || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">booker</td><td>{{ qualificationAiPreview.debugVars.booker_name || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">call_date</td><td>{{ qualificationAiPreview.debugVars.call_date || '-' }}</td></tr>
                  <tr><td class="font-weight-bold">transcript_length</td><td>{{ qualificationAiPreview.debugVars.transcript_length || 0 }} chars</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="qualificationAiPreview.debugPrompt" class="mt-3">
            <div class="card p-3 border-warning">
              <h6 class="text-warning mb-1">Prompt sent to AI</h6>
              <textarea class="form-control form-control-sm" rows="4" readonly :value="qualificationAiPreview.debugPrompt"></textarea>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="closeQualificationAiPreviewModal()">
              Cancel
            </button>
            <button
              class="btn btn-success"
              :disabled="qualificationAiPreview.saving || !qualificationAiPreview.newResult.tag"
              @click="confirmQualificationAiUpdate()"
            >
              <span v-if="!qualificationAiPreview.saving">Update Qualification AI value</span>
              <span v-else>Saving...</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
    <Modal name="modalEvaluations" class="modal-preview p-2" :size="'65'" :close="true" height="100" style="z-index: 10">
      <!-- evaluation task of booker   -->
      <div class="pb-5">
        <div class="p-4 text-center">
          <label>
            <h4>Evaluation Tasks of {{ bdrEvaluation.bdr_name }}</h4>
          </label>
          <hr>
        </div>
        <div class="row mb-0 pb-5 mr-5">
          <div class="col-md-9 ml-5">
            <div class="row mb-4">
              <div class="col-md-6 ml-1 mb-1">
                <span
                  class="badge px-2 py-1"
                  :style="bdrEvaluation.task_fake == 1 ? 'background:#dc3545;color:#fff' : bdrEvaluation.task_fake == 2 ? 'background:#fd7e14;color:#fff' : bdrEvaluation.task_fake == 3 ? 'background:#28a745;color:#fff' : 'background:#6c757d;color:#fff'"
                >
                  {{ bdrEvaluation.task_fake == 1 ? 'FAKE' : bdrEvaluation.task_fake == 2 ? 'ABUSIF' : bdrEvaluation.task_fake == 3 ? 'VALIDE' : '-' }}
                </span>
              </div>
              <div class="col-md-12 ml-1 mb-3" v-if="bdrEvaluation.task_verifier_justification">
                <label class="font-weight-bold small">Verifier justification:</label>
                <textarea 
                  class="form-control" 
                  rows="3" 
                  readonly 
                  :value="bdrEvaluation.task_verifier_justification"
                ></textarea>
              </div>
              <div class="col-md-12 ml-1 pb-5">
                <div class="d-flex align-items-center">
                  <treeselect
                    v-model="bdrEvaluation.task_score_options"
                    :options="optionsEvaluationScore"
                    :multiple="true"
                    :searchable="true"
                    placeholder="Search and select clients"
                    class="flex-grow-1 mr-1"
                  />
                  <button
                    class="btn btn-success btn-sm mt-1"
                    @click="setScoreInTasks(bdrEvaluation.task_score_options, bdrEvaluation.notification_id)"
                  >
                    <span>Eval Score</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <EmailHistory
      modal-name="bdr-answer-emails-conversation"
      :client="emailHistoryClient"
      :emails="emailHistoryEmails"
      :visible="emailHistoryVisible"
      :loading="emailHistoryLoading"
      @close="onEmailHistoryClose"
    />
  </main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { monitorService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { adminService, notificationService, usersService, opportunitiesService,businessContactsService,openaiService } from "@/_services";
import TableV2 from "@/components/Common/TableV2.vue";
import Pagination from "@/components/Common/Pagination.vue";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import emptyperson from "@/assets/images/emptyperson.png";
import { statusBadgeMixin } from "@/_mixins/";
import EmbedCalendar from "@/components/Calendar/EmbedCalendar.vue";
import Modal from "@/components/Common/Modal.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import EmailHistory from "@/components/Common/EmailHistory.vue";
import ColdCallPrepBar from "@/components/ColdCall/ColdCallPrepBar.vue";
import ColdCallConsignes from "@/components/ColdCall/ColdCallConsignes.vue";
import ColdCallObjection from "@/components/ColdCall/ColdCallObjection.vue";
import { coldCallScriptMixin } from "@/components/ColdCall/coldCallScriptMixin";
import { all } from "core-js/fn/promise";

// Paleta Client Status.
const clientStatusColors = [
  { id: "1", label: "Proposal", bgColor: "gray", textColor: "#FFFFFF" },
  { id: "2", label: "Outdated", bgColor: "orange", textColor: "#FFFFFF" },
  { id: "3", label: "Preparing", bgColor: "#FF8C00", textColor: "#FFFFFF" },
  { id: "4", label: "Active", bgColor: "green", textColor: "#FFFFFF" },
  { id: "5", label: "Stand By", bgColor: "#279CF5", textColor: "#FFFFFF" },
  { id: "6", label: "Deleted", bgColor: "red", textColor: "#FFFFFF" },
  { id: "7", label: "Recovering", bgColor: "#F5AD27", textColor: "#FFFFFF" },
  { id: "8", label: "Pending Deleted", bgColor: "red", textColor: "#FFFFFF" },
  { id: "9", label: "Validation", bgColor: "yellow", textColor: "#000000" },
];

// Paleta de la columna Température (itemBadge por link_status_temperature_id).
const temperatureColors = [
  { id: 1, label: "Urgent", bgColor: "#008000", textColor: "#FFFFFF" },
  { id: 2, label: "Positive", bgColor: "#008000", textColor: "#FFFFFF" },
  { id: 3, label: "Introduction", bgColor: "#0000FF", textColor: "#FFFFFF" },
  { id: 4, label: "Wrong Contact", bgColor: "#0000FF", textColor: "#FFFFFF" },
  { id: 5, label: "Negative", bgColor: "#0000FF", textColor: "#FFFFFF" },
  { id: 6, label: "Calendar Inspection", bgColor: "#00FFFF", textColor: "#000000" },
  { id: 7, label: "Reschedule", bgColor: "#FFFF00", textColor: "#000000" },
  { id: 8, label: "Cold", bgColor: "#000000", textColor: "#FFFFFF" },
  { id: 9, label: "Other Answer", bgColor: "#FF9966", textColor: "#000000" },
];

// Paleta de la columna Task Output (resultado de la tarea del booker).
const taskOutputColors = [
  { id: "Meeting Booked", label: "Meeting Booked", bgColor: "green", textColor: "#FFFFFF" },
  { id: "Call back", label: "Call back", bgColor: "yellow", textColor: "gray" },
  { id: "No answer", label: "No answer", bgColor: "gray", textColor: "white" },
  { id: "No phone", label: "No phone", bgColor: "orange", textColor: "white" },
  { id: "No interest", label: "No interest", bgColor: "red", textColor: "#FFFFFF" },
  { id: "Neutral", label: "Neutral", bgColor: "red", textColor: "#FFFFFF" },
  { id: "Out of scope", label: "Out of scope", bgColor: "red", textColor: "#FFFFFF" },
  { id: "Out of scope company", label: "Out of scope company", bgColor: "red", textColor: "#FFFFFF" },
  { id: "Wrong contact", label: "Wrong contact", bgColor: "red", textColor: "#FFFFFF" },
  { id: "Invalid number", label: "Invalid number", bgColor: "red", textColor: "#FFFFFF" },
  { id: "empty", label: "Empty", bgColor: "#008000", textColor: "#FFFFFF" },
];

// Paleta de la columna Clasification (ids alineados con normalizeCalification).
const clasificationColors = [
  { id: "new_meeting", label: "New meeting", bgColor: "#28a745", textColor: "#FFFFFF", tooltipRowField: "calification_response" },
  { id: "rescheduled_meeting", label: "Rescheduled meeting", bgColor: "#fd7e14", textColor: "#FFFFFF", tooltipRowField: "calification_response" },
  { id: "no_meeting", label: "No meeting", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "calification_response" },
];

// Config de la columna Action: audios, iconos, conversación y badges de estado de llamada.
const actionMultipleCol = {
  type: "multiple",
  conditions: [
    { value_if: "transcription_ai_result", value: "No pitch", class: "icon-check1 text-success mr-2", type: "icon", type2: "emit", emit: "showTranscriptions" },
    { value_if: "transcription_ai_result", value: "No need", class: "icon-cross text-danger mr-2", type: "icon", type2: "emit", emit: "showTranscriptions" },
    { value_if: "transcription_ai_result", value: "Not the right person", class: "icon-cross text-warning mr-2", type: "icon", type2: "emit", emit: "showTranscriptions" },
    //{ value_if: "entity_type", value: "ringover_event", type: "audio", value_source_type: "source_type", value_conversation_id: "call_id", },
    { value_if: "entity_type", value: "ringover_event", type: "audio2", value_source_type: "source_type", value_conversation_id: "call_id", value_audio: "record"},
    { value_if: "has_transcription", value: "1", class: "icon-bars text-primary mr-2", type: "icon", type2: "emit", emit: "showTranscriptions" },
    { value_if: "entity_type", value: "email_sent", class: "text-primary", type: "button", type2: "emit", emit: "showConversation", name: "View Conversation" },
    { value_if: "entity_type", value: "ringover_event", class: "icon-phone text-primary", type: "icon", type2: "emit", emit: "showCall" },
    { value_if: "call_counts", value: "call_counts", type: "bubble", type2: "emit", emit: "showCall" },
    {
      badges: [
        { badge_if: "last_state", badge_value: "FAILED", badge_class: "badge badge-danger text-white", badge_label: "CALL : FAILED" },
        { badge_if: "last_state", badge_value: "CANCELLED", badge_class: "badge badge-warning text-white", badge_label: "CALL : CANCELLED" },
        { badge_if: "last_state", badge_value: "CALL_ID_FAILED", badge_class: "badge badge-danger text-white", badge_label: "CALL : FAILED" },
      ],
    },
    { value_if: "incall_duration", value: "incall_duration", type: "text"},
  ],
};

// Paleta de Qualification appel (solo llamadas; tooltip desde qualification_response).
const qualificationColors = [
  { id: "MEETING_BOOKED", label: "Meeting booked", bgColor: "#28a745", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "MEETING_RESCHEDULED", label: "Meeting rescheduled", bgColor: "#fd7e14", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "MEETING_REFUSED_SEND_EMAIL", label: "Meeting refused (send email)", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "CALLBACK_REQUESTED", label: "Callback requested", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "SOFT_REFUSAL", label: "Soft refusal", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "HARD_REFUSAL", label: "Hard refusal", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "OPT_OUT_REQUEST", label: "Opt out request", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "WRONG_PERSON", label: "Wrong person", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "NOT_DECISION_MAKER", label: "Not decision maker", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "OUT_OF_SCOPE", label: "Out of scope", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "CALL_INTERRUPTED", label: "Call interrupted", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "VOICEMAIL_PITCH_LEFT", label: "Voicemail pitch left", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "VOICEMAIL_NO_PITCH", label: "Voicemail no pitch", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
  { id: "NO_ANSWER", label: "No answer", bgColor: "#6c757d", textColor: "#FFFFFF", tooltipRowField: "qualification_response" },
];

// Paleta de la columna Objection (transcription_ai_result del agente).
const objectionColors = [
  { id: "no pitch", label: "No pitch", bgColor: "#008000", textColor: "#FFFFFF" },
  { id: "no need", label: "No need", bgColor: "#008000", textColor: "#FFFFFF" },
  { id: "not the moment", label: "Not the moment", bgColor: "#0000FF", textColor: "#FFFFFF" },
  { id: "not the right person", label: "not the right person", bgColor: "#0000FF", textColor: "#FFFFFF" },
  { id: "already with competitor", label: "already with competitor", bgColor: "#0000FF", textColor: "#FFFFFF" },
  { id: "other", label: "Other", bgColor: "#FF9966", textColor: "#000000" },
];

// Cabeceras de TableV2: orden, etiqueta y grupo (Contexte / booker / agent / result).
const bdrTasksV2Headers = [
  { label: "Opportunité", group: "contexte", class: "overflowhide" },
  { label: "Client", group: "contexte", class: "overflowhide" },
  { label: "Température", group: "contexte", class: "overflowhide" },
  { label: "Contact", group: "contexte", class: "overflowhide" },
  { label: "Date création", group: "contexte", class: "overflowhide" },
  { label: "BDR", group: "booker", class: "overflowhide" },
  { label: "Type", group: "booker", class: "overflowhide text-center" },
  { label: "Script", group: "booker", class: "overflowhide text-center" },
  { label: "Action", group: "booker", class: "overflowhide" },
  { label: "Task Output", group: "booker", class: "overflowhide" },
  { label: "Tasks Done", group: "booker", class: "overflowhide" },
  // { label: "Clasification", group: "booker", class: "overflowhide" },
  { label: "Contact établi (appel)", group: "agent", class: "overflowhide" },
  { label: "Qualification appel", group: "agent", class: "overflowhide" },
  { label: "Objection", group: "agent", class: "overflowhide" },
  { label: "Meeting (AI)", group: "agent", class: "overflowhide" },
  { label: "AI vs Meeting", group: "agent", class: "overflowhide text-center", size: "90px", percentage: "90px" },
  { label: "Meeting", group: "result", class: "overflowhide" },
  { label: "Verifier", group: "result", class: "overflowhide bdr-verifier-column", size: "60px", percentage: "60px" },
  { label: "Winner", group: "result", class: "overflowhide" },
];

// Definición de celdas por columna (type, campos API, emits). Índice alineado con bdrTasksV2Headers.
const bdrTasksV2Cols = [
  [{ type: "stackedLink", value_label: "business_name", value_emit: "link_id", sub_value: "link_id", emit: "goToOpportunity" }],
  [{
    type: "stackedClient",
    value_label: "client_name",
    value_emit: "client_id",
    sub_value: "client_status",
    statusIdField: "client_status_id",
    statusColors: clientStatusColors,
    emit: "goToAgency",
    showStatusDot: true,
  }],
  [{ value: "link_status_temperature_id", type: "itemBadge", class: "badge badge-primary", colors: temperatureColors }],
  [{ type: "stackedText", primary_value: "buasiness_contact_name", sub_value: "contact_phone" }],
  [{ type: "stackedDateTime", value: "created" }],
  [{
    type: "stackedText",
    primary_value: "bdr_name",
    sub_value: "date_task_done",
    sub_prefix: "clôt. ",
    sub_format: "datetime",
  }],
  [{ type: "taskTypeIcon", taskTypeIdField: "task_type_id", taskTypeField: "task_type" }],
  [{ class: "icon-file-text", type: "emit", emit: "getOpportunityById", value_emit: "link_id", scriptBtn: true, title: "Voir le script" }],
  [actionMultipleCol],
  [{ value: "task_output", type: "itemBadge", class: "badge badge-primary", colors: taskOutputColors }],
  [{ value: "tasks_done", class: "text-primary" }],
  // [{ value: "calification", type: "itemBadge", class: "badge", colors: clasificationColors }],
  [{
    callOnly: true,
    badges: [
      { badge_if: "result", badge_value: "wrongnumber", badge_label: "Wrong number" },
      { badge_if: "result", badge_value: "Conversation", badge_label: "Conversation" },
      { badge_if: "result", badge_value: "nointeraction", badge_label: "No interaction" },
    ],
  }],
  //[{ callOnly: true, value: "qualification", type: "itemBadge", class: "badge", colors: qualificationColors }],
  [
    { 
      callOnly: true, 
      value: "qualification", 
      type: "itemAndActionButton", 
      class: "badge", 
      colors: qualificationColors,
      rerunEmit: "runQualificationAi",
      value_emit: "notification_id",
    }
  ],
  [{ callOnly: true, value_if: "transcription_ai_result", value: "transcription_ai_result", type: "itemBadge", class: "badge badge-primary", colors: objectionColors }],
  [{
    type: "meetingAiCard",
    taskNumberField: "meeting_task_number",
    statusField: "calification_call",
    responseField: "calification_call_response",
    emailStatusField: "calification",
    emailResponseField: "calification_response",
    rerunEmit: "runMeetingAi",
    value_emit: "notification_id",
  }],
  [{
    type: "meetingAiComparison",
    taskNumberField: "meeting_task_number",
    taskDateField: "meeting_task_date",
    contactField: "meeting_contact_name",
    statusField: "calification_call",
    responseField: "calification_call_response",
    emailStatusField: "calification",
    emailResponseField: "calification_response",
  }],
  [{
    type: "meetingResult",
    taskNumberField: "meeting_task_number",
    taskDateField: "meeting_task_date",
    contactField: "meeting_contact_name",
    statusField: "calification_call",
    responseField: "calification_call_response",
    emailStatusField: "calification",
    emailResponseField: "calification_response",
    emit: "createMeetingFromCall",
  }],
  [
    {
      value: "task_fake", type: "itemBadge", class: "badge",
      colors: [
        { id: 1, label: "FAKE", bgColor: "#dc3545", textColor: "#FFFFFF", tooltipRowField: "task_verifier_justification", tooltipFallbackKey: "lang.label.verifier_no_justification" },
        { id: 2, label: "ABUSIF", bgColor: "#fd7e14", textColor: "#FFFFFF", tooltipRowField: "task_verifier_justification", tooltipFallbackKey: "lang.label.verifier_no_justification" },
        { id: 3, label: "VALIDE", bgColor: "#28a745", textColor: "#FFFFFF", tooltipRowField: "task_verifier_justification", tooltipFallbackKey: "lang.label.verifier_no_justification" },
      ],
    },
    { type: "btnIfNotNull", format: 3, value_if: "can_review", value_equals: "1", adminOnly: true, label: "↺", class: "btn btn-primary btn-sm themed-button effect-btn ml-1 px-2 py-0", emit: "runVerifier", value_emit: "notification_id" },
  ],
  [{ value: "bdr_name_winner", class: "text-primary" }],
];

// Etiquetas y clases CSS de la fila de grupos en el thead de TableV2.
const bdrTasksColumnGroups = {
  contexte: { label: "Contexte", headerClass: "g-context", cellClass: "col-context" },
  booker: { label: "Travail du booker", headerClass: "g-human", cellClass: "col-human" },
  agent: { label: "Analyse des agents", headerClass: "g-agent", cellClass: "col-agent" },
  result: { label: "Résultat", headerClass: "g-result", cellClass: "col-result" },
};

// Leyenda bajo la tabla: color de cada bloque de columnas.
const bdrTasksTableLegends = [
  { label: "Contexte", color: "#F4F4F6", border: "#E8E8EE" },
  { label: "Travail du booker", color: "#EEEEFC", border: "#4B4BE1" },
  { label: "Analyse des agents", color: "#DEF0F2", border: "#0E6E7A" },
  { label: "Résultat", color: "#F4F4F6", border: "#E8E8EE" },
];

export default {
  name: "BdrTasks",
  components: { TableV2, Pagination, LoadingSpinner, Treeselect, EmbedCalendar, Modal, Tooltip, EmailHistory, ColdCallPrepBar, ColdCallConsignes, ColdCallObjection },
  props: {
    condition: {
      type: String,
      default: "all"
    },
    targetId: {
      type: String,
      default: "0"
    },
    withMeeting: {
      type: Array,
      default: null
    },
    withIputRange: {
      type: Boolean,
      default: true
    },
    clientId: {
      type: [Number, String],
      default: null
    },
    withTaskType: {
      type: Array,
      default: null
    },
    user_bdr_id: {
      type: [Number, String],
      default: null
    },
    withCheckbox: {
      type: Boolean,
      default: false
    },
    downloading: {
      type: Boolean,
      default: false
    }

  },
  mixins: [statusBadgeMixin, coldCallScriptMixin],
  data() {
    return {
      selectedTaskIds: [],
      emailHistoryVisible: false,
      emailHistoryLoading: false,
      emailHistoryEmails: [],
      emailHistoryClient: null,
      processingAllItems: false,
      currentLinkId:0,
      currentBusinessContact: false,
      loadingSpeach: false,
      openprompt: false,
      loadingCallPromptInspect: false,
      loadingRegenerateCallScript: false,
      callPromptInspect: null,
      callPromptInspectError: null,
      loadingPhone: false,
      opportunity: {},
      pushButton: true,
      selectedBusinessContact: null,
      isLoading: false,
      showMore: false,
      answersIndex: 99,
      clients: [],
      bdrEvaluation: [
        {
          notification_id: 0,
          bdr_name: "",
          task_fake: 0,
          task_score_options: [],
          task_verifier_justification: ""
        }
      ],
      optionsEvaluationScore: [
        { id: 1, label: this.$t("lang.label.eval_task_fake_1") },
        { id: 2, label: this.$t("lang.label.eval_task_fake_2") },
        { id: 3, label: this.$t("lang.label.eval_task_fake_3") },
        { id: 4, label: this.$t("lang.label.eval_task_fake_4") },
        { id: 5, label: this.$t("lang.label.eval_task_fake_5") },
        { id: 6, label: this.$t("lang.label.eval_task_fake_6") },
      ],
      openAiAnswers: [
        {
          answersIndex: 99,
          prompts: false,
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 0,
          prompts: "callprompt_notinterest",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 1,
          prompts: "callprompt_sendemail",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 2,
          prompts: "callprompt_phonenumber",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 3,
          prompts: "callprompt_inmeeting",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 4,
          prompts: "callprompt_intern",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 5,
          prompts: "callprompt_norightperson",
          result: "",
          promptResult: "",
          loading: false,
        },
      ],
      answersIndex: 99,
      filteredClients: [],
      withMeetingOptions: [
        { id: 1, label: this.$t("lang.button.yes") },
        { id: 0, label: this.$t("lang.label.no") }
      ],
      completeLoading: false,
      total: 10,
      refreshButtonAI: 2,
      total_actions: 0,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1
      },
      list: [],
      listAllItems: [],
      email: {},
      bdrUserOptions: [],
      taskTypeOptions: [
        {
          id: "coldphoning",
          label: this.$t("lang.task.callcontact_title")
        },
        {
          id: "manualanswer",
          label: this.$t("lang.task.manualanswer_title")
        },
        {
          id: "reminder",
          label: "Reminder Task"
        },
        {
          id: "absent",
          label: "Absent Event"
        },
        {
          id: "calendar",
          label: "Calendar activity with no event"
        },
        {
          id: "cancelled",
          label: "Cancelled Event"
        }
      ],
      temperatureStatuseOptions: [
        {
          id: "1",
          label: "Urgent"
        },
        {
          id: "2",
          label: "Positive"
        },
        {
          id: "3",
          label: "Introduction"
        },
        {
          id: "4",
          label: "Wrong contact"
        },
        {
          id: "5",
          label: "Negative"
        },
        {
          id: "6",
          label: "Calendar inspection"
        },
        {
          id: "7",
          label: "Reschedule"
        },
        {
          id: "8",
          label: "Cold"
        },
        {
          id: "9",
          label: "Other Answer"
        }
      ],
      oppStatusOptions: [
        {
          id: "canceled",
          label: "Canceled"
        },
        {
          id: "absent",
          label: "Absent"
        },
        {
          id: "on",
          label: "On"
        },
        {
          id: "off",
          label: "Off"
        }
      ],
      taskOutputOptions: [
        {
          id: 1,
          label: "Meeting Booked",
        },
        {
          id: 2,
          label: "Call back",
        },
        {
          id: 3,
          label: "No answer",
        },
        {
          id: 4,
          label: "No phone",
        },
        {
          id: 5,
          label: "No interest",
        },
          {
          id: 6,
          label: "Neutral",
        },
          {
          id: 7,
          label: "Out of scope",
        },
          {
          id: 8,
          label: "Out of scope company",
        },
        {
          id: 9,
          label: "Wrong contact",
        },
        {
          id: 10,
          label: "Invalid number",
        },
      ],
      callStatusOptions: [
        {
          id: "CONVERSATION",
          label: "Conversation",
        },
        {
          id: "NO INTERACTION",
          label: "No Interaction",
        },
        {
          id: "WRONG NUMBER",
          label: "Wrong Number",
        },
      ],
      callDurationOptions: [
        {
          id: "+15s",
          label: "More than 15 seconds",
        },
        {
          id: "+20s",
          label: "More than 20 seconds",
        },
        {
          id: "+30s",
          label: "More than 30 seconds",
        },
        {
          id: "+60s",
          label: "More than 60 seconds",
        },
        {
          id: "+90s",
          label: "More than 90 seconds",
        },
        {
          id: "+120s",
          label: "More than 120 seconds",
        },
      ],
      meetingAIOptions: [
        { id: "New meeting", label: "Créer un meeting" },
        { id: "No meeting", label: "Pas de meeting" },
        { id: "Rescheduled meeting", label: "Reprogrammer" },
      ],
      meetingAiMismatchOptions: [
        { id: "mismatch", label: "Différent" },
        { id: "match", label: "Identique" },
      ],
      objectionOptions: objectionColors.map((item) => ({
        id: item.id,
        label: item.label,
      })),
      qualificationsOptions: qualificationColors.map((item) => ({
        id: item.id,
        label: item.label,
      })),
      contactEstablishedOptions: [
        { id: "Conversation", label: "Conversation" },
        { id: "nointeraction", label: "No interaction" },
        { id: "wrongnumber", label: "Wrong number" },
      ],
      domainhttpsindex: 32322332,
      limit: 120,
      lastFilters: [],
      callsToShow: [],
      transcriptions: [],
      verifierPreview: {
        loading: false,
        saving: false,
        notification_id: null,
        hasTranscription: false,
        debugPrompt: "",
        debugVars: null,
        current: {
          task_fake: 0,
          justification: "",
        },
        newResult: {
          task_fake: 0,
          justification: "",
        },
        override: {
          task_fake: null,
          motif: "",
        },
      },
      meetingAiPreview: {
        loading: false,
        saving: false,
        notification_id: null,
        debugPrompt: "",
        debugVars: null,
        current: {
          meeting_status: "",
          response: "",
        },
        newResult: {
          meeting_status: "",
          response: "",
        },
      },
      qualificationAiPreview: {
        loading: false,
        saving: false,
        notification_id: null,
        ringover_event_id: null,
        debugPrompt: "",
        debugVars: null,
        current: {
          tag: "",
          description: "",
        },
        newResult: {
          tag: "",
          description: "",
        },
      },
      oppLoading: true,
      callsRecords: [],
      callsSourceType: null,
      callsConversationId: null,
        temperatureBgColors: [
        {
          id: 1,
          prompt: "callprompt_urgent",
          label: "Urgent",
          bgColor: "#008000",
          textColor: "#FFFFFF",
          description:
            "The prospect appears to be looking to schedule a meeting",
        },
        {
          id: 2,
          prompt: "callprompt_positive",
          label: "Positive",
          bgColor: "#008000",
          textColor: "#FFFFFF",
          description: "The prospect seems open to a meeting",
        },
        {
          id: 3,
          prompt: "callprompt_introduction",
          label: "Introduction",
          bgColor: "#0000FF",
          textColor: "#FFFFFF",
          description: "We received a manual reply from the prospect",
        },
        {
          id: 4,
          label: "Wrong Contact",
          bgColor: "#0000FF",
          textColor: "#FFFFFF",
          description: "We received a manual reply from the prospect",
        },
        {
          id: 5,
          label: "Negative",
          bgColor: "#0000FF",
          textColor: "#FFFFFF",
          description: "We received a manual reply from the prospect",
        },
        {
          id: 6,
          prompt: "callprompt_inspection",
          label: "Calendar Inspection",
          bgColor: "#00FFFF",
          textColor: "#000000",
          description: "The prospect has been on the customer's agenda",
        },
        {
          id: 7,
          prompt: "callprompt_absent",
          label: "Reschedule",
          bgColor: "#FFFF00",
          textColor: "#000000",
          description: "Rescheduling a meeting",
        },
        {
          id: 8,
          prompt: "callprompt_cold",
          label: "Cold",
          bgColor: "#C0C0C0",
          textColor: "#FFFFFF",
          description: "No interaction has yet been detected.",
        },
        {
          id: 9,
          prompt: "callprompt_otheranswer",
          label: "Other Answer",
          bgColor: "#FF9966",
          textColor: "#000000",
          description: "We received a manual reply with other answer.",
        },
      ],
      filters: {
        client: null,
        taskOutputFilter: [],
        bdrUserFilter: [],
        taskTypeFilter: [],
        oppStatusFilter: [],
        temperatureStatusFilter: [],
        callStatusFilter: [],
        callDurationFilter: [],
        meetingAIFilter: [],
        meetingAiMismatchFilter: [],
        objectionFilter: [],
        qualificationsFilter: [],
        contactEstablishedFilter: [],
        targetId: this.targetId,
        withMeeting: [],
        linkIdFilter: null,
        booker_type: "all",
        range: {
          startDate: moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD")
        }
      },
      simpleheader: bdrTasksV2Headers,
      simplecols: bdrTasksV2Cols,
      columnGroups: bdrTasksColumnGroups,
      tableLegends: bdrTasksTableLegends,
      exportHeader: [
        {
          label: this.$t("lang.column.creationdate"),
          class: "overflowhide"
        },
        {
          label: "BDR",
          class: "overflowhide"
        },
        {
          label: "Type",
          class: "overflowhide"
        },
        {
          label: "Tasks Done",
          class: "overflowhide",
        },
        {
          label: "Action",
          class: "overflowhide"
        },
        // {
        //   label: "Clasification",
        //   class: "overflowhide"
        // },        
        {
          label: "Opportunity ID",
          class: "overflowhide"
        },
        {
          label: "Opportunity",
          class: "overflowhide"
        },
        {
          label: "Script",
          class: "overflowhide"
        },
        {
          label: "Date close",
          class: "overflowhide"
        },
        {
          label: "Client",
          class: "overflowhide"
        },
        {
          label: "Client Status",
          class: "overflowhide",
        },
        {
          label: "Opportunity Temperature",
          class: "overflowhide"
        },
        {
          label: "Task Output",
          class: "overflowhide"
        },
        {
          label: "Meeting Planned",
          class: "overflowhide"
        },
        {
          label: "Verifier",
          class: "overflowhide bdr-verifier-column",
          size: "60px",
          percentage: "60px"
        },
        {
          label: "Winner",
          class: "overflowhide"
        },
        {
          label: "Contact name",
          class: "overflowhide"
        },
        {
          label: "Contact phone",
          class: "overflowhide"
        },
        {
          label: "Contact établi (appel)",
          class: "overflowhide"
        },
        {
          label: "Qualification appel",
          class: "overflowhide"
        },
        {
          label: "Objection",
          class: "overflowhide"
        },
        {
          label: "Meeting (AI)",
          class: "overflowhide"
        },
        {
          label: "Créer le meeting",
          class: "overflowhide"
        }
        // {
        //   label: "Call",
        //   class: "overflowhide",
        // },
      ],
      exportCols: [
        [
          {
            value: "created",
            class: "text-primary"
          }
        ],
        [
          {
            value: "bdr_name",
            class: "text-primary"
          }
        ],
        [
          {
            value: "task_type",
            class: "text-primary"
          }
        ],
        [
          {
            value: "tasks_done",
            class: "text-primary",
          },
        ],
        [
          {
            type: "multiple",
            conditions: [
              // {
              //   badges: [
              //     {
              //       badge_if: "transcription_ai_result",
              //       badge_value: "no pitch",
              //       badge_class: "badge badge-danger text-white mr-2",
              //       badge_label: "No pitch"
              //     },
              //     {
              //       badge_if: "transcription_ai_result",
              //       badge_value: "no need",
              //       badge_class: "badge badge-secondary text-white",
              //       badge_label: "No need"
              //     },
              //     {
              //       badge_if: "transcription_ai_result",
              //       badge_value: "not the moment",
              //       badge_class: "badge badge-warning text-white",
              //       badge_label: "Not the moment"
              //     },
              //     {
              //       badge_if: "transcription_ai_result",
              //       badge_value: "not the right person",
              //       badge_class: "badge badge-black text-white",
              //       badge_label: "Not the right person"
              //     },
              //     {
              //       badge_if: "transcription_ai_result",
              //       badge_value: "already with competitor",
              //       badge_class: "badge badge-primary text-white",
              //       badge_label: "Already with competitor"
              //     },
              //      {
              //       badge_if: "transcription_ai_result",
              //       badge_value: "other",
              //       badge_class: "badge badge-secondary text-white",
              //       badge_label: "Other"
              //     }
              //   ]
              // },
              {
                value_if: "transcription_ai_result",
                value: "No pitch",
                class: "icon-check1 text-success mr-2",
                type: "icon",
                type2: "emit",
                emit: "showTranscriptions",
              },
              {
                value_if: "transcription_ai_result",
                value: "No need",
                class: "icon-cross text-danger mr-2",
                type: "icon",
                type2: "emit",
                emit: "showTranscriptions",
              },
              {
                value_if: "transcription_ai_result",
                value: "Not the right person",
                class: "icon-cross text-warning mr-2",
                type: "icon",
                type2: "emit",
                emit: "showTranscriptions",
              },
              {
                value_if: "entity_type",
                value: "ringover_event",
                type: "audio"
              },
              {
                value_if: "has_transcription",
                value: "1",
                class: "icon-bars text-primary mr-2",
                type: "icon",
                type2: "emit",
                emit: "showTranscriptions",
              },
              {
                value_if: "entity_type",
                value: "email_sent",
                class: "text-primary",
                type: "button",
                type2: "emit",
                emit: "showConversation",
                name: "View Conversation"
              },
              {
                value_if: "entity_type",
                value: "ringover_event",
                class: "icon-phone text-primary",
                type: "icon",
                type2: "emit",
                emit: "showCall"
              },
              {
                value_if: "call_counts",
                value: "call_counts",
                type: "bubble",
                type2: "emit",
                emit: "showCall"
              },

              {
                badges: [
                  {
                    badge_if: "last_state",
                    badge_value: "FAILED",
                    badge_class: "badge badge-danger text-white",
                    badge_label: "CALL : FAILED"
                  },
                  // {
                  //   badge_if: "last_state",
                  //   badge_value: "ANSWERED",
                  //   badge_class: "badge badge-success text-white",
                  //   badge_label: "ANSWERED",
                  // },
                  {
                    badge_if: "last_state",
                    badge_value: "CANCELLED",
                    badge_class: "badge badge-warning text-white",
                    badge_label: "CALL : CANCELLED"
                  },
                  {
                    badge_if: "last_state",
                    badge_value: "CALL_ID_FAILED",
                    badge_class: "badge badge-danger text-white",
                    badge_label: "CALL : FAILED"
                  }
                ]
              }
            ]
          }
        ],
        // [
        //     {
        //       value: "calification",
        //       type: "itemBadge",
        //       class: "badge",
        //       colors: [
        //         {
        //           id: "New meeting",
        //           label: "New meeting",
        //           bgColor: "#28a745",
        //           textColor: "#FFFFFF",
        //           tooltipRowField: "calification_response",
        //         },
        //         {
        //           id: "Rescheduled meeting",
        //           label: "Rescheduled meeting",
        //           bgColor: "#fd7e14",
        //           textColor: "#FFFFFF",
        //           tooltipRowField: "calification_response",
        //         },
        //         {
        //           id: "No meeting",
        //           label: "No meeting",
        //           bgColor: "#6c757d",
        //           textColor: "#FFFFFF",
        //           tooltipRowField: "calification_response",
        //         },
        //       ],
        //     },
        //   ],
        [
          {
            value: "link_id"
          }
        ],
        [
          {
            value_label: "business_name",
            value_emit: "link_id",
            class: "text-primary",
            type: "emit",
            emit: "goToOpportunity"
          }
        ],
        [
          {
            class: "icon-eye text-primary",
            type: "emit",
            emit: "getOpportunityById",
            value_emit: "link_id",
          }
        ],
        [
          {
            value: "date_task_done",
            class: "text-primary"
          }
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency"
          }
        ],
        [
          {
            value: "client_status",
          },
        ],
        [
          {
            value: "link_status_temperature_id",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: 1,
                label: "Urgent",
                bgColor: "#008000",
                textColor: "#FFFFFF"
              },
              {
                id: 2,
                label: "Positive",
                bgColor: "#008000",
                textColor: "#FFFFFF"
              },
              {
                id: 3,
                label: "Introduction",
                bgColor: "#0000FF",
                textColor: "#FFFFFF"
              },
              {
                id: 4,
                label: "Wrong Contact",
                bgColor: "#0000FF",
                textColor: "#FFFFFF"
              },
              {
                id: 5,
                label: "Negative",
                bgColor: "#0000FF",
                textColor: "#FFFFFF"
              },
              {
                id: 6,
                label: "Calendar Inspection",
                bgColor: "#00FFFF",
                textColor: "#000000"
              },
              {
                id: 7,
                label: "Reschedule",
                bgColor: "#FFFF00",
                textColor: "#000000"
              },
              {
                id: 8,
                label: "Cold",
                bgColor: "#000000",
                textColor: "#FFFFFF"
              },
              {
                id: 9,
                label: "Other Answer",
                bgColor: "#FF9966",
                textColor: "#000000"
              }
            ]
          }
        ],

        [
          {
            value: "task_output",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: "Meeting Booked",
                label: "Meeting Booked",
                bgColor: "green",
                textColor: "#FFFFFF"
              },
              {
                id: "Call back",
                label: "Call back",
                bgColor: "yellow",
                textColor: "gray"
              },
              {
                id: "No answer",
                label: "No answer",
                bgColor: "gray",
                textColor: "white"
              },
              {
                id: "No phone",
                label: "No phone",
                bgColor: "orange",
                textColor: "white"
              },
              {
                id: "No interest",
                label: "No interest",
                bgColor: "red",
                textColor: "#FFFFFF"
              },
              {
                id: "Neutral",
                label: "Neutral",
                bgColor: "red",
                textColor: "#FFFFFF"
              },
              {
                id: "Out of scope",
                label: "Out of scope",
                bgColor: "red",
                textColor: "#FFFFFF"
              },
                 {
                id: "Out of scope company",
                label: "Out of scope company",
                bgColor: "red",
                textColor: "#FFFFFF"
              },
              {
                id: "Wrong contact",
                label: "Wrong contact",
                bgColor: "red",
                textColor: "#FFFFFF"
              },
              {
                id: "Invalid number",
                label: "Invalid number",
                bgColor: "red",
                textColor: "#FFFFFF"
              },
              {
                id: "empty",
                label: "Empty",
                bgColor: "#008000",
                textColor: "#FFFFFF"
              }
            ]
          }
        ],
        [
          {
            badges: [
              {
                badge_if: "meeting_planned",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_icon: "icon-check-circle"
              }
            ]
          }
        ],
        [
          {
            value: "task_fake",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: 1,
                label: "FAKE",
                bgColor: "#dc3545",
                textColor: "#FFFFFF",
                tooltipRowField: "task_verifier_justification",
                tooltipFallbackKey: "lang.label.verifier_no_justification"
              },
              {
                id: 2,
                label: "ABUSIF",
                bgColor: "#fd7e14",
                textColor: "#FFFFFF",
                tooltipRowField: "task_verifier_justification",
                tooltipFallbackKey: "lang.label.verifier_no_justification"
              },
              {
                id: 3,
                label: "VALIDE",
                bgColor: "#28a745",
                textColor: "#FFFFFF",
                tooltipRowField: "task_verifier_justification",
                tooltipFallbackKey: "lang.label.verifier_no_justification"
              }
            ]
          },
          {
            type: "btnIfNotNull",
            format: 3,
            value_if: "can_review",
            value_equals: "1",
            adminOnly: true,
            label: "↺",
            class: "btn btn-primary btn-sm themed-button effect-btn ml-1 px-2 py-0",
            emit: "runVerifier",
            value_emit: "notification_id"
          }
        ],
        [
          {
            value: "bdr_name_winner",
            class: "text-primary"
          }
        ],
        [
          {
            value: "buasiness_contact_name",
            class: "text-primary"
          }
        ],
        [
          {
            value: "contact_phone",
            class: "text-primary"
          }
        ],
        [
          {
            value_label: "Result",
            class: "text-primary",
            textShort: 40,
            badges: [
              {
                badge_if: "result",
                badge_value: "wrongnumber",
                badge_class: "badge badge-danger text-white",
                badge_label: "Wrong number",
              },
              {
                badge_if: "result",
                badge_value: "Conversation",
                badge_class: "badge badge-success text-white",
                badge_label: "Conversation",
              },
              {
                badge_if: "result",
                badge_value: "nointeraction",
                badge_class: "badge badge-secondary text-white",
                badge_label: "No interaction",
              },
            ],
          },
        ],
        [
          {
            value: "qualification",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "MEETING_BOOKED",
                label: "MEETING BOOKED",
                bgColor: "#28a745",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "MEETING_RESCHEDULED",
                label: "MEETING RESCHEDULED",
                bgColor: "#fd7e14",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "MEETING_REFUSED_SEND_EMAIL",
                label: "MEETING REFUSED SEND EMAIL",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "CALLBACK_REQUESTED",
                label: "CALLBACK REQUESTED",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "SOFT_REFUSAL",
                label: "SOFT REFUSAL",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "HARD_REFUSAL",
                label: "HARD REFUSAL",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "OPT_OUT_REQUEST",
                label: "OPT OUT REQUEST",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "WRONG_PERSON",
                label: "WRONG PERSON",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "NOT_DECISION_MAKER",
                label: "NOT DECISION MAKER",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "OUT_OF_SCOPE",
                label: "OUT OF SCOPE",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "CALL_INTERRUPTED",
                label: "CALL INTERRUPTED",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "VOICEMAIL_PITCH_LEFT",
                label: "VOICEMAIL PITCH LEFT",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "VOICEMAIL_NO_PITCH",
                label: "VOICEMAIL NO PITCH",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
              {
                id: "NO_ANSWER",
                label: "NO ANSWER",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "qualification_response",
              },
            ],
          },
        ],
        [
          {
            value_if: "transcription_ai_result",
            value: "transcription_ai_result",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: 'no pitch',
                label: "No pitch",
                bgColor: "#008000",
                textColor: "#FFFFFF"
              },
              {
                id: 'no need',
                label: "No need",
                bgColor: "#008000",
                textColor: "#FFFFFF"
              },
              {
                id: 'not the moment',
                label: "Not the moment",
                bgColor: "#0000FF",
                textColor: "#FFFFFF"
              },
              {
                id: 'not the right person',
                label: "not the right person",
                bgColor: "#0000FF",
                textColor: "#FFFFFF"
              },
              {
                id: 'already with competitor',
                label: "already with competitor",
                bgColor: "#0000FF",
                textColor: "#FFFFFF"
              },
              {
                id: 'other',
                label: "Other",
                bgColor: "#FF9966",
                textColor: "#000000"
              }
            ]
          },
        ],
        [
          {
            value: "calification_call",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "New meeting",
                label: "New meeting",
                bgColor: "#28a745",
                textColor: "#FFFFFF",
                tooltipRowField: "calification_call_response",
              },
              {
                id: "Rescheduled meeting",
                label: "Rescheduled meeting",
                bgColor: "#fd7e14",
                textColor: "#FFFFFF",
                tooltipRowField: "calification_call_response",
              },
              {
                id: "No meeting",
                label: "No meeting",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
                tooltipRowField: "calification_call_response",
              },
            ],
          },
        ],
        [
          {
            value1: "calification_call",
            value2: "meeting_task_number",
            type: "CreateMeetingButton",
            emit: "createMeetingFromCall",
          }
        ],
        // [
        //   {
        //     value_audio: "record",
        //     type: "audio",
        //   },
        // ],

        // [
        //   {
        //     value_if: "entity_type",
        //     value: "email_sent",
        //     type: "icon",
        //     class: "icon-envelope text-primary",
        //     type2: "emit",
        //     emit: "showEmail",
        //   },
        // ],
      ],
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day")
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day")
      }
    };
  },

  created() {
    this.getClients()
    this.getUserBdr();
    this.getBdrTaskList();
 
  },
  beforeDestroy() {
    document.querySelectorAll('audio[id^="audio-"]').forEach(el => {
      if (el.src && el.src.startsWith("blob:")) {
        URL.revokeObjectURL(el.src);
      }
    });
  },
  computed: {
    bdrTaskListQty() {
      return this.list.length;
    },
    callPromptInspectShortcodes() {
      if (!this.callPromptInspect || !this.callPromptInspect.shortcodes) {
        return [];
      }
      return Object.keys(this.callPromptInspect.shortcodes).map((token) => ({
        token,
        value: this.formatShortcodeValue(this.callPromptInspect.shortcodes[token]),
      }));
    },
    ...mapState({
      currentUser: state => state.authentication.user
    }),
    isVerifierAdmin() {
      return Number(this.currentUser && this.currentUser.role_id) === 1;
    },
    canForceVerifierOverride() {
      const override = this.verifierPreview && this.verifierPreview.override;
      if (!override || this.verifierPreview.saving) return false;
      const taskFake = Number(override.task_fake);
      const motif = (override.motif || "").trim();
      return [1, 2, 3].includes(taskFake) && motif.length > 0;
    },
    canAcceptVerifierAiResult() {
      if (this.verifierPreview.saving || !this.verifierPreview.newResult.task_fake) {
        return false;
      }
      const motif = (
        (this.verifierPreview.override && this.verifierPreview.override.motif) ||
        ""
      ).trim();
      return motif.length === 0;
    },
  },
  methods: {
    getToDownload() {
      const allItems = 1; // cuando quieres pedir todos los resultados sin limite
      this.getBdrTaskList(allItems);
    },
    onTasksSelectionChange(ids) {
      const incoming = Array.isArray(ids) ? ids : [ids];
      incoming.forEach((id) => {
        if (id === undefined || id === null) return;
        const idx = this.selectedTaskIds.indexOf(id);
        if (idx > -1) {
          this.selectedTaskIds.splice(idx, 1);
        } else {
          this.selectedTaskIds.push(id);
        }
      });
    },
    downloadSelectedTasks() {
      if (this.downloading) return;
      if (!this.selectedTaskIds.length) return;
      this.$emit("download-selected-tasks", this.selectedTaskIds.slice());
    },
    analyseClientCalls() {
      if (!this.selectedTaskIds.length) return;
      this.$emit("analyse-client-calls", this.selectedTaskIds.slice());
    },
    createMeetingFromCall(row) {
      const calendarLink = row && row.calendar_link;
      if (!calendarLink) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.error"),
          text: "Calendar link not available",
        });
        return;
      }
      let payload = null;
      payload = this.parseCallResponse(row);

      const normalizedLink = this.normalizeCalendarLink(calendarLink);
      const url = this.appendPrefillData(normalizedLink, payload);
      window.open(url, "_blank", "noopener,noreferrer");
    },
    parseCallResponse(row) {
      let raw = row && row.calification_call_response;
      if (!raw || raw === "empty" || !String(raw).trim()) {
        raw = row && row.calification_response;
      }
      if (!raw || raw === "empty" || !String(raw).trim()) {
        return null;
      }
      let parsed = typeof raw === "string" ? JSON.parse(raw.trim()) : raw;
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }
      return parsed;
    },
    appendPrefillData(calendarLink, payload) {
      const url = new URL(calendarLink);
      url.searchParams.set("data", JSON.stringify(payload));
      return url.toString();
    },
    normalizeCalendarLink(calendarLink) {
      try {
        const url = new URL(calendarLink);
        const parts = url.pathname.split("/").filter(Boolean);
        const calendarIndex = parts.indexOf("calendar");

        if (calendarIndex === -1 || calendarIndex >= parts.length - 1) {
          return calendarLink;
        }

        const accountSegment = parts[calendarIndex + 1];
        parts[calendarIndex + 1] = /^\d+$/.test(accountSegment)
          ? btoa(accountSegment)
          : accountSegment;
        url.pathname = "/" + parts.join("/");

        return url.toString();
      } catch (error) {
        return calendarLink;
      }
    },
    download() {   

      const nameDocument = "report-list-booker-tasks.csv";

      const headers = this.exportHeader.map(h => h.label);

      const fields = this.exportCols.map( item => {
        const value = (item[0].value) ? item[0].value : item[0].value_label;
        return value;
      })

      const rows = this.listAllItems.map( item => {
        return fields.map( col => {
          return item[col];
        }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
      })

      const csv = `${headers.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      },
    openModalEvaluation(id) {
      this.bdrEvaluation = this.list.find(item => item.notification_id == id);
      console.log(this.bdrEvaluation);
      this.$modal.show('modalEvaluations');
    },
    closeModalEvaluations() {
      this.$modal.hide('modalEvaluations');
    },
    parseVerifierJustification(justification) {
      if (!justification) return '-';
      try {
        const parsed = JSON.parse(justification);
        return parsed.justification || parsed.result || justification;
      } catch (e) {
        return justification;
      }
    },
    getVerifierLabel(taskFake) {
      const value = Number(taskFake);
      if (value === 1) return "FAKE";
      if (value === 2) return "ABUSIF";
      if (value === 3) return "VALIDE";
      return "-";
    },
    getVerifierBadgeStyle(taskFake) {
      const value = Number(taskFake);
      if (value === 1) return "background:#dc3545;color:#fff";
      if (value === 2) return "background:#fd7e14;color:#fff";
      if (value === 3) return "background:#28a745;color:#fff";
      return "background:#6c757d;color:#fff";
    },
    getVerifierOverrideOptionStyle(taskFake) {
      const selected = Number(this.verifierPreview.override.task_fake) === Number(taskFake);
      const base = this.getVerifierBadgeStyle(taskFake);
      return selected
        ? `${base};border:2px solid #212529;opacity:1`
        : `${base};border:2px solid transparent;opacity:0.65`;
    },
    resetVerifierPreview(notification_id = null) {
      this.verifierPreview = {
        loading: false,
        saving: false,
        notification_id,
        hasTranscription: false,
        debugPrompt: "",
        debugVars: null,
        current: {
          task_fake: 0,
          justification: "",
        },
        newResult: {
          task_fake: 0,
          justification: "",
        },
        override: {
          task_fake: null,
          motif: "",
        },
      };
    },
    closeVerifierPreviewModal() {
      this.$modal.hide("verifier-preview-modal");
    },
    resetMeetingAiPreview(notification_id = null) {
      this.meetingAiPreview = {
        loading: false,
        saving: false,
        notification_id,
        debugPrompt: "",
        debugVars: null,
        current: {
          meeting_status: "",
          response: "",
        },
        newResult: {
          meeting_status: "",
          response: "",
        },
      };
    },
    closeMeetingAiPreviewModal() {
      this.$modal.hide("meeting-ai-preview-modal");
    },
    runMeetingAi(notification_id) {
      this.resetMeetingAiPreview(notification_id);
      this.meetingAiPreview.loading = true;
      this.$modal.show("meeting-ai-preview-modal");

      openaiService.previewMeetingAi(notification_id).then((result) => {
        this.meetingAiPreview.current = {
          meeting_status: result.current && result.current.meeting_status ? result.current.meeting_status : "",
          response: result.current && result.current.response ? result.current.response : "",
        };
        this.meetingAiPreview.newResult = {
          meeting_status: result.meeting_status || "",
          response: result.response || "",
        };
        this.meetingAiPreview.debugPrompt = result.debug_prompt_preview || "";
        this.meetingAiPreview.debugVars = result.debug_vars || null;
      }).catch((error) => {
        const message = error && error.message ? error.message : "Error launching Meeting AI";
        this.closeMeetingAiPreviewModal();
        this.$swal({ type: "error", title: message });
      }).finally(() => {
        this.meetingAiPreview.loading = false;
      });
    },
    confirmMeetingAiUpdate() {
      const { notification_id, newResult } = this.meetingAiPreview;
      if (!notification_id || !newResult.meeting_status || !newResult.response) {
        return;
      }

      this.meetingAiPreview.saving = true;
      openaiService
        .updateMeetingAiResult(notification_id, newResult.meeting_status, newResult.response)
        .then(() => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.closeMeetingAiPreviewModal();
          this.getBdrTaskList();
        })
        .catch(() => {
          this.$swal({ type: "error", title: "Error saving Meeting AI result" });
        })
        .finally(() => {
          this.meetingAiPreview.saving = false;
        });
    },
    resetQualificationAiPreview(notification_id = null) {
      this.qualificationAiPreview = {
        loading: false,
        saving: false,
        notification_id,
        ringover_event_id: null,
        debugPrompt: "",
        debugVars: null,
        current: {
          tag: "",
          description: "",
        },
        newResult: {
          tag: "",
          description: "",
        },
      };
    },
    closeQualificationAiPreviewModal() {
      this.$modal.hide("qualification-ai-preview-modal");
    },
    runQualificationAi(notification_id) {
      this.resetQualificationAiPreview(notification_id);
      this.qualificationAiPreview.loading = true;
      this.$modal.show("qualification-ai-preview-modal");

      adminService.getCallQualification(notification_id).then((result) => {
        const oldRes = result.result_old || {};
        const newRes = result.result || {};
        const variables = result.variables || {};

        this.qualificationAiPreview.ringover_event_id = result.ringover_event_id || null;
        this.qualificationAiPreview.current = {
          tag: oldRes.tag || "",
          description: oldRes.description || "",
        };
        this.qualificationAiPreview.newResult = {
          tag: newRes.tag || "",
          description: newRes.description || "",
        };
        this.qualificationAiPreview.debugPrompt = result.prompt || "";
        this.qualificationAiPreview.debugVars = {
          notification_id: result.notification_id || notification_id,
          ringover_event_id: result.ringover_event_id || "-",
          prospect_name: [variables.prospect_firstname, variables.prospect_lastname].filter(Boolean).join(" ") || "-",
          prospect_phone: variables.prospect_phone || "-",
          prospect_email: variables.prospect_email || "-",
          booker_name: [variables.booker_firstname, variables.booker_lastname].filter(Boolean).join(" ") || "-",
          call_date: variables.call_date || "-",
          transcript_length: variables.transcript_call ? variables.transcript_call.length : 0,
        };
      }).catch((error) => {
        const message = error && error.message ? error.message : "Error launching Qualification AI";
        this.closeQualificationAiPreviewModal();
        this.$swal({ type: "error", title: message });
      }).finally(() => {
        this.qualificationAiPreview.loading = false;
      });
    },
    confirmQualificationAiUpdate() {
      
      console.log("qualificationAiPreview", this.qualificationAiPreview);

      const { notification_id, newResult } = this.qualificationAiPreview;
      if (!notification_id || !newResult.tag) {
        return;
      }

      this.qualificationAiPreview.saving = true;
      adminService
        .updateQualificationByNotification(notification_id, newResult.tag, newResult)
        .then(() => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.closeQualificationAiPreviewModal();
          this.getBdrTaskList();
        })
        .catch(() => {
          this.$swal({ type: "error", title: "Error saving Qualification AI result" });
        })
        .finally(() => {
          this.qualificationAiPreview.saving = false;
        });
    },
    runVerifier(notification_id) {
      if (!this.isVerifierAdmin) {
        return;
      }

      const currentRow = this.list.find(item => item.notification_id == notification_id) || {};
      const hasTranscription = String(currentRow.has_transcription) === "1";

      this.resetVerifierPreview(notification_id);
      this.verifierPreview.hasTranscription = hasTranscription;
      this.verifierPreview.current = {
        task_fake: currentRow.task_fake || 0,
        justification: currentRow.task_verifier_justification || "",
      };
      this.$modal.show("verifier-preview-modal");

      if (!hasTranscription) {
        this.verifierPreview.loading = false;
        return;
      }

      this.verifierPreview.loading = true;
      openaiService.previewVerifier(notification_id).then((result) => {
        this.verifierPreview.newResult = {
          task_fake: result.task_fake || 0,
          justification: result.justification || "",
        };
        this.verifierPreview.debugPrompt = result.debug_prompt_preview || "";
        this.verifierPreview.debugVars = result.debug_vars || null;
      }).catch((error) => {
        const message = error && error.message ? error.message : "Error launching Verifier";
        this.closeVerifierPreviewModal();
        this.$swal({ type: "error", title: message });
      }).finally(() => {
        this.verifierPreview.loading = false;
      });
    },
    confirmVerifierUpdate() {
      if (!this.isVerifierAdmin || !this.canAcceptVerifierAiResult) {
        return;
      }

      const { notification_id, newResult } = this.verifierPreview;
      const justification = (newResult.justification || "").trim();
      if (!notification_id || !newResult.task_fake || !justification) {
        return;
      }

      this.verifierPreview.saving = true;
      openaiService
        .updateVerifierResult(notification_id, newResult.task_fake, justification)
        .then(() => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.closeVerifierPreviewModal();
          this.getBdrTaskList();
        })
        .catch((error) => {
          const message =
            (error && error.message) || "Error saving Verifier result";
          this.$swal({ type: "error", title: message });
        })
        .finally(() => {
          this.verifierPreview.saving = false;
        });
    },
    confirmVerifierOverride() {
      if (!this.isVerifierAdmin || !this.canForceVerifierOverride) {
        return;
      }

      const { notification_id, override } = this.verifierPreview;
      const taskFake = Number(override.task_fake);
      const motif = (override.motif || "").trim();

      this.verifierPreview.saving = true;
      openaiService
        .updateVerifierResult(notification_id, taskFake, motif)
        .then(() => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.closeVerifierPreviewModal();
          this.getBdrTaskList();
        })
        .catch((error) => {
          const message =
            (error && error.message) || "Error saving Verifier override";
          this.$swal({ type: "error", title: message });
        })
        .finally(() => {
          this.verifierPreview.saving = false;
        });
    },
    setTasksInFake(task_fake, notification_id){
      this.$swal({
        type: "warning",
        title: this.$t("lang.column.evaluation"),
        text: this.$t("lang.label.text_evaluation_tasks"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonColor: "#d33a2c",
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if(result.value){
          notificationService.setTaskFake(notification_id, task_fake).then((response) => {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.datasavedsuccessfully"),
              text: this.$t("lang.label.emailSettingSuccessfully"),
              showConfirmButton: false,
              timer: 2500,
            });
          })
        }
      })
    },

    setScoreInTasks(task_score_options, notification_id){
      let task_score;
      if(task_score_options.length == 0){
        task_score = 0.0;
        task_score_options = null;
      }else{
        task_score = parseFloat((task_score_options.length / 6 * 100).toFixed(1));
      }

      notificationService.setTaskScore(task_score, task_score_options, notification_id).then((response) => {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.datasavedsuccessfully"),
          showConfirmButton: false,
          timer: 2500,
        });
        this.closeModalEvaluations();
      })

    },

    onSearchChange(searchQuery) {
      if (searchQuery.length > 1) {
        const query = searchQuery.toLowerCase();
        this.filteredClients = this.clients.filter((client) =>
          client.label.toLowerCase().includes(query)
        );
      } else {
        this.filteredClients = []
      }
    },
    getClients() {
      const toCreateUser = 1;
      monitorService.getClients(null, "2,3,4,5,9", toCreateUser)
        .then(res => {
          this.clients = res
          if (this.filters.client) {
            this.filteredClients = this.clients.filter(client => client.id == this.filters.client)
          }
        })
        .catch(err => console.log(err));
    },
    capitalizeFirstLetter(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    },
    checkCalendly() {
      if (
        this.opportunity.campaignTokens.my_calendar_link.value.includes(
          "calendly"
        )
      ) {
        // contiene "calendly"
        console.log("Es un enlace de Calendly");
        return true;
      } else {
        return false;
      }
    },
      getLinkId() {
      let linkid = "linkid:";
      return btoa(linkid + this.opportunity.link.id);
    },
    isBdrUser() {
      if (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2) {
        this.bdr_user_id = this.currentUser.id;
        return true;
      } else {
        return false;
      }
    },
    isBookerManager() {
      return (
        this.currentUser.role_id == 2 &&
        this.currentUser.booker &&
        this.currentUser.booker.status === "Booker Manager"
      );
    },

    hasPhones() {
      return (
        this.selectedBusinessContact &&
        this.selectedBusinessContact.event_phone &&
        this.selectedBusinessContact.event_phone.length > 0
      );
    },
    checkLoading() {
      return this.openAiAnswers.some(
        (item) => item.loading && item.answersIndex == this.answersIndex
      );
    },
    phoneList() {
      if (!this.selectedBusinessContact.event_phone) return [];
      return this.selectedBusinessContact.event_phone.split(",");
    },

    showEmail(email) {
      this.email = {
        subject: email.sent_subject,
        from: email.sent_from,
        to: email.sent_to,
        message: email.sent_message
      };
      this.$modal.show("showMail");
    },

    showConversation(row) {
      const {link_id, sent_to} = row

      if (!link_id || !String(sent_to || "").trim()) {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: "Missing link or recipient email for this row.",
            showConfirmButton: true,
          });
          return;
      }

      this.emailHistoryClient = row.client_name
          ? { client_name: row.client_name }
          : null;
        this.emailHistoryEmails = [];
        this.emailHistoryVisible = true;
        this.emailHistoryLoading = true;

        adminService
          .getLinkEmailMessages(link_id, sent_to)
          .then((rows) => {
            this.emailHistoryEmails = Array.isArray(rows) ? rows : [];
          })
          .catch((err) => {
            this.emailHistoryEmails = [];
            const msg =
              err && err.message
                ? err.message
                : this.$t("lang.label.error");
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text: msg,
              showConfirmButton: true,
            });
          })
          .finally(() => {
            this.emailHistoryLoading = false;
          });



      console.log(link_id, sent_to)
      //this.$modal.show("showMail");
    },

    onEmailHistoryClose() {
        this.emailHistoryVisible = false;
        this.emailHistoryEmails = [];
        this.emailHistoryClient = null;
    },
    showCall(call) {
      //console.log(call);
      this.callsToShow = call.calls_states;
      let records = call.calls;
      this.callsRecords = records;
      // source_type y call_id vienen a nivel de tarea (no por llamada).
      // Para ElevenLabs: source_type === 'elevenlabs' y call_id = conversation_id.
      this.callsSourceType = call.source_type || null;
      this.callsConversationId = call.call_id || null;
      this.$modal.show("showCalls");
    },
    async onElevenLabsPlay(conversationId, ev) {
      const audioEl = ev.target;
      if (audioEl.dataset.loaded === "1") return;
      ev.preventDefault();
      audioEl.pause();
      try {
        const blob = await adminService.getElevenLabsAudio(conversationId);
        audioEl.src = URL.createObjectURL(blob);
        audioEl.dataset.loaded = "1";
        audioEl.play();
      } catch (error) {
        console.error("Error cargando audio ElevenLabs:", error);
      }
    },
    showTranscriptions(call) {
      //console.log(call);
      this.transcriptions = call.calls_transcriptions;
      this.$modal.show("transcription-modal");
    },

    getUserBdr() {
      if (this.user_bdr_id != null) {
        return false;
      }

      if (this.isBookerManager()) {
        usersService
          .getBdrs(0, 0, 0, 0, 1)
          .then((res) => {
            const team = Array.isArray(res.result) ? res.result : [];
            const managerOption = {
              id: this.currentUser.id,
              name: [this.currentUser.name, this.currentUser.lastname]
                .filter(Boolean)
                .join(" "),
            };
            const withoutManager = team.filter(
              (booker) => Number(booker.id) !== Number(managerOption.id)
            );
            this.bdrUserOptions = [managerOption, ...withoutManager];
          })
          .catch((err) => consolelog(err));
        return;
      }

      if (this.isBdrUser()) {
        return false;
      }

      usersService
        .getBdrs()
        .then((res) => {
          this.bdrUserOptions = res.result;
        })
        .catch((err) => consolelog(err));
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name
      };
    },
    truncatedText() {
      return this.opportunity.link.short_description != null &&
        this.opportunity.link.short_description.length > this.limit
        ? this.opportunity.link.short_description.substring(0, this.limit) +
        "..."
        : this.opportunity.link.short_description;
    },
    getBdrTaskList(allItems = 0) {
      if (JSON.stringify(this.filters) != JSON.stringify(this.lastFilters)) {
        this.getBdrTaskTotal();
      }

      const taskOutputList = [
        "Meeting Booked",
        "Call back",
        "No answer",
        "No phone",
        "No interest",
        "Neutral",
        "Out of scope",
        "Out of scope company",
        "Wrong contact",
        "Invalid number",
      ];

      if(allItems != 1){
        this.completeLoading = false;
      } 

      let filters = this.filters;
      filters.cantPerPage = this.pagination.cantPerPage;
      filters.currentPage = this.pagination.currentPage;
      filters.getTotal = 0;
      filters.allItems = allItems
      if(allItems == 1){        
        this.processingAllItems = true;
      }

      if (this.user_bdr_id != null && !this.isBookerManager()) {
        filters.bdrUserFilter = [this.user_bdr_id];
      }
      if (this.withMeeting) {
        filters.withMeeting = this.withMeeting
      }
      if (this.withTaskType) {
        filters.taskTypeFilter = this.withTaskType
      }
      if (this.clientId != null) {
        filters.client = this.clientId;
      }
      if (!this.withIputRange) {
        delete filters.range;
      }
      notificationService.getBdrTaskList(filters).then(result => {
        if (result) {    
            result.forEach(item => {
            item.calification = this.normalizeCalification(item.calification),
            item.task_fake = item.task_fake == null ?  0 : item.task_fake;
            item.task_score = item.task_score == null ? 0 : item.task_score;
            item.task_score_options = Array.isArray(item.task_score_options) ? item.task_score_options : (typeof item.task_score_options === 'string' ? (() => { try { const a = JSON.parse(item.task_score_options); return Array.isArray(a) ? a : []; } catch { return []; } })() : []);
            item.task_type_id = this.getTaskTypeId(item.task_type);
            item.task_type = this.getTaskTypeTitle(item.task_type);

            item.record = null;
            if (item.calls) {
              const firstCall = item.calls.split(",")[0];
              const firstUrl = firstCall ? firstCall.split("|")[0] : null;
              item.record = firstUrl && firstUrl !== "NULL" ? firstUrl : null;
            }

            if (item.calls) {
              let calls = item.calls.split(",");
              //console.log(calls);
              item.call_counts = calls.length;
              item.calls_states = [];
              item.calls = [];
              calls.forEach(el => {
                let state = el.split("|");
                //console.log("state :" + state[1]);
                // El backend envia el string literal "NULL" cuando no hay URL
                // (caso ElevenLabs); lo normalizamos a null.
                let url = state[0] === "NULL" ? null : state[0];
                item.calls.push(url);
                item.calls_states.push(state[1]);
              });
              //item.calls_states = calls;
            }
            if (item.calls_transcriptions) {
              item.calls_transcriptions = item.calls_transcriptions.split("|");
            } else {
              item.calls_transcriptions = [];
            }

            item.task_output =
              item.task_output != null
                ? taskOutputList[item.task_output - 1]
                : "empty";
          });

          if (this.filters.client) {
            this.filteredClients = this.clients.filter(client => client.id == this.filters.client)
          }
        } else {
          this.notifications = [];
          this.total = 0;
        }

        if(allItems == 1){
          this.listAllItems = result
          this.download();
          this.processingAllItems = false;
        } else {
          this.list = result
          this.lastFilters = JSON.parse(JSON.stringify(this.filters));
          this.completeLoading = true;
        }

        //console.log(this.list);
      });
    },
    normalizeCalification(raw) {
        if (raw === null || raw === undefined || raw === "") {
          return "empty";
        }
        const s = String(raw).trim().toLowerCase();
        const compact = s.replace(/\s+/g, "_");
        if (
          s === "new meeting" ||
          compact === "new_meeting" ||
          s === "1" ||
          s === "newmeeting"
        ) {
          return "new_meeting";
        }
        if (
          s === "rescheduled meeting" ||
          compact === "rescheduled_meeting" ||
          s === "2" ||
          (s.includes("reschedule") && s.includes("meeting"))
        ) {
          return "rescheduled_meeting";
        }
        if (
          s === "no meeting" ||
          compact === "no_meeting" ||
          s === "3" ||
          s === "nomeeting"
        ) {
          return "no_meeting";
        }
        return "empty";
      },
    getBdrTaskTotal() {
      this.pagination.currentPage = 1;
      this.total = 0;
      let filters = this.filters;
      filters.cantPerPage = this.pagination.cantPerPage;
      filters.currentPage = this.pagination.currentPage;
      filters.getTotal = 1;
      if (this.withMeeting) {
        filters.withMeeting = this.withMeeting
      }
      if (this.withTaskType) {
        filters.taskTypeFilter = this.withTaskType
      }
      if (this.clientId != null) {
        filters.client = this.clientId;
      }
      if (!this.withIputRange) {
        delete filters.range;
      }
      notificationService.getBdrTaskList(filters).then(result => {
        this.total = result.total;
        this.total_actions = result.total_actions;
      });
    },
    goToOpportunity(link_id) {
      window.open("/opportunities/" + link_id, "_blank");
    },
   existAvatarEnterprice() {
      if(this.opportunity.link.userBilling){
        var avatar = this.opportunity.link.userBilling.avatar;
        return avatar ? avatar : emptyperson;
      }else{
        return emptyperson;
      }
    },
    toggleExpand() {
      this.showMore = !this.showMore;
    },
        getOpenAiResult() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      return foundItem ? foundItem.result : null; // Devuelve 'result' si existe, de lo contrario 'null'
    },
    getOpenAiPrompt() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      return foundItem ? foundItem.promptResult : null;
    },
    getCurrentCallPromptParams() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      let callprompt = foundItem && foundItem.prompts ? foundItem.prompts : this.getPromptType();
      return {
        callprompt,
        business_contact_id: this.selectedBusinessContact.id,
        link_id: this.opportunity.link.id,
        target_id: this.opportunity.link.target_id,
        prospectors_name: this.opportunity.link.label_from || "",
      };
    },
    formatShortcodeValue(value) {
      if (value === null || value === undefined || value === "") {
        return "(empty)";
      }
      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }
      return String(value);
    },
    inspectCallPrompt() {
      this.callPromptInspect = null;
      this.callPromptInspectError = null;
      this.loadingCallPromptInspect = true;
      this.$modal.show("callPromptInspectModal");

      openaiService.inspectCallPrompt(this.getCurrentCallPromptParams()).then(
        (result) => {
          this.callPromptInspect = result.data || null;
          if (!this.callPromptInspect) {
            this.callPromptInspectError = result.message || null;
          }
          this.loadingCallPromptInspect = false;
        },
        (error) => {
          this.callPromptInspectError =
            typeof error === "string" ? error : this.$t("lang.general.error");
          this.loadingCallPromptInspect = false;
        }
      );
    },
    regenerateCallScript() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      if (!foundItem || !this.selectedBusinessContact) {
        return;
      }

      if (!foundItem.prompts) {
        foundItem.prompts = this.getPromptType();
      }

      this.loadingRegenerateCallScript = true;
      this.loadingSpeach = true;
      foundItem.loading = true;
      foundItem.result = "";
      foundItem.promptResult = "";

      const params = {
        ...this.getCurrentCallPromptParams(),
        force_regenerate: true,
      };

      openaiService.getCallPrompt(params).then(
        (result) => {
          if (!result.data || result.data.length === 0) {
            foundItem.result = result.message || "EMPTY";
          } else {
            foundItem.result = result.data[0].replaceAll("<br>", "\n");
            foundItem.promptResult = result.prompt;
          }
          foundItem.loading = false;
          this.loadingRegenerateCallScript = false;
          this.loadingSpeach = false;
        },
        () => {
          foundItem.loading = false;
          this.loadingRegenerateCallScript = false;
          this.loadingSpeach = false;
        }
      );
    },
    getOpportunity(link_id) {
      if(link_id != this.currentLinkId){
        this.currentLinkId = link_id;
        // Otra tarea: volver a Main Script. Las objeciones (100 + i) de la
        // tarea anterior pueden no existir en este order.
        this.answersIndex = 99;
        this.oppLoading = true
      this.$modal.show('aiscript');
      opportunitiesService.getOpportunityById(link_id, null)
        .then((response) => {
          this.opportunity = response
          this.loadColdCallScript(this.opportunity.link && this.opportunity.link.target_id)
          this.selectedBusinessContact = this.opportunity.business_contacts[0]
          console.log(this.opportunity)
          this.oppLoading = false
          this.getSpeach()
        })
        .catch((error) => {
          console.error("Error fetching opportunity:", error);
        });

      }else{
        this.$modal.show('aiscript');
      }
      
    },
    goToAgency(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    getPromptType() {
      const itemFound = this.temperatureBgColors.find(
        (e) => e.id == this.opportunity.link.link_status_temperature_id
      );

      if (itemFound) {
        return itemFound.prompt;
      }

      return false;
    },

    getSpeach(prompt) {
      this.currentBusinessContact = this.selectedBusinessContact;

      this.loadingSpeach = true;
      this.pushButton = true;

      this.openAiAnswers.forEach((item) => {
        item.loading = true;
        if (!item.prompts) {
          item.prompts = this.getPromptType();
        }

        let params = {
          callprompt: item.prompts,
          business_contact_id: this.currentBusinessContact.id,
          link_id: this.opportunity.link.id,
          target_id: this.opportunity.link.target_id,
          prospectors_name:  '',
        };
  
       
          openaiService.getCallPrompt(params).then((result) => {
            if (!result || !result.data || result.data.length == 0) {
              this.callOpenaiResult = result && result.message;
              item.result = "EMPTY";
            } else {
              item.result = result.data[0].replaceAll("<br>", "\n");
              item.promptResult = result.prompt;
            }

            item.loading = false;

            this.loadingSpeach = false;
          }).catch(() => {
            // Error de la generacion: parar el spinner. Con "EMPTY" la modal
            // muestra el Pitch del AM si existe (ccShowPitchFallback).
            item.result = "EMPTY";
            item.loading = false;
            this.loadingSpeach = false;
          });
     

      });
    },

      async findPhoneNumber(contact) {
      this.loadingPhone = true;
      let datas = {
        enrich_fields: ["contact.phones"],
      };

      if (
        contact.email &&
        contact.email.substring(contact.email.indexOf("@"))
      ) {
        datas.domain =
          "www." + contact.email.substring(contact.email.indexOf("@") + 1);
      }

      if (contact.name) {
        const parts = contact.name.split(" ");
        const firstName = parts[0];
        const lastName = parts.slice(1).join(" ");

        datas.firstname = firstName;
        datas.lastname = lastName;
      }

      if (contact.linkedinurl) {
        datas.linkedinurl = contact.linkedinurl;
      }

      const dataToFindPhone = {
        name: "get phone to oliversale on client",
        business_contacts_id: contact.id,
        datas: [
          {
            ...datas,
          },
        ],
      };

      try {
        const result = await businessContactsService.requestPhoneTofullenrich(
          dataToFindPhone
        );

        // Llamamos a la función que intenta obtener el teléfono con reintentos
        const phoneData = await this.retryGetPhone(contact.id);

        if (phoneData === "empty") {
          let contact_updated;
          this.loadingPhone = false;
          contact_updated = new Date().toISOString();
          contact.source_phone = "FullEnrich";
        } else {
          this.updateBusinessContacts(phoneData);
        }
      } catch (error) {
        console.error("Error al obtener teléfono:", error);
      }
      this.loadingPhone = false;
    },
        getLanguage(language_id) {
      if (language_id == 4) {
        return "italian";
      }
      if (language_id == 2) {
        return "english";
      }
      if (language_id == 3) {
        return "spanish";
      }
      if (language_id == 5) {
        return "portugues";
      }
    },
    getTaskTypeId(raw) {
      if (!raw) return null;
      if (typeof raw === "string" && raw.indexOf("lang.") !== -1) {
        try {
          const message = JSON.parse(raw);
          const key = message.lang_message || "";
          if (key.includes("coldphoning") || key.includes("callcontact")) return "coldphoning";
          if (key.includes("manualanswer")) return "manualanswer";
          if (key.includes("reminder")) return "reminder";
          if (key.includes("absent")) return "absent";
          if (key.includes("calendar")) return "calendar";
          if (key.includes("cancelled")) return "cancelled";
        } catch (e) {
          return null;
        }
      }
      return raw;
    },
    getTaskTypeTitle(title) {
      if (!title || typeof title !== "string") return title;
      if (title.indexOf("lang.") !== -1) {
        let message = JSON.parse(title);
        return this.$t(message.lang_message);
      }
      return title;
    }
  }
};
</script>

<style>
.bdr-tasks-page {
  --bdr-surface: #ffffff;
  --bdr-surface-2: #f4f4f6;
  --bdr-border: #e8e8ee;
  --bdr-border-2: #d6d6df;
  --bdr-text: #1c1c28;
  --bdr-text-2: #5a5a6e;
  --bdr-text-3: #9a9aab;
  --bdr-primary: #4b4be1;
  --bdr-go: #1d9e75;
  --bdr-radius: 14px;
  --bdr-radius-sm: 8px;
}

.bdr-tasks-head {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 18px;
}

.bdr-tasks-head__icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--bdr-primary);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 17px;
}

.bdr-tasks-head__title {
  font-size: 18px;
  font-weight: 600;
  color: var(--bdr-text);
  margin: 0;
}

.bdr-tasks-head__subtitle {
  font-size: 12.5px;
  color: var(--bdr-text-2);
  margin: 2px 0 0;
}

.bdr-tasks-head__subtitle strong {
  color: var(--bdr-text);
  font-weight: 600;
}

.bdr-tasks-head__sep {
  margin: 0 6px;
}

.bdr-tasks-head__calculating {
  color: var(--bdr-primary);
}

.bdr-tasks-filters {
  background: var(--bdr-surface-2);
  border-radius: var(--bdr-radius);
  padding: 13px 15px;
  margin-bottom: 16px;
}

.bdr-tasks-filters__row {
  margin-left: -6px;
  margin-right: -6px;
}

.bdr-tasks-filters__row + .bdr-tasks-filters__row {
  margin-top: 10px;
}

.bdr-tasks-filters__row--action {
  margin-top: 12px;
}

.bdr-tasks-filters__cell {
  padding-left: 6px;
  padding-right: 6px;
}

.bdr-tasks-filters__label {
  display: block;
  font-size: 10.5px;
  font-weight: 600;
  color: var(--bdr-text-3);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
}

.bdr-tasks-filters__date-range {
  display: flex;
  align-items: center;
  gap: 7px;
  background: var(--bdr-surface);
  border: 0.5px solid var(--bdr-border);
  border-radius: var(--bdr-radius-sm);
  padding: 5px 11px;
  min-height: 34px;
}

.bdr-tasks-filters__date-icon {
  color: var(--bdr-text-3);
  font-size: 14px;
  flex-shrink: 0;
}

.bdr-tasks-filters__date-input {
  flex: 1;
  min-width: 0;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  font-size: 12.5px;
  color: var(--bdr-text-2);
  padding: 0 !important;
}

.bdr-tasks-filters__date-sep {
  color: var(--bdr-text-3);
  font-size: 12px;
  flex-shrink: 0;
}

.bdr-tasks-filters__select.vue-treeselect {
  font-size: 12.5px;
}

.bdr-tasks-filters .vue-treeselect__control {
  border: 0.5px solid var(--bdr-border-2);
  border-radius: var(--bdr-radius-sm);
  background: var(--bdr-surface);
  min-height: 34px;
}

.bdr-tasks-filters .vue-treeselect__placeholder,
.bdr-tasks-filters .vue-treeselect__single-value {
  font-size: 12.5px;
  color: var(--bdr-text);
}

.bdr-tasks-filters__go-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 15px;
  border-radius: var(--bdr-radius-sm);
  border: none;
  background: var(--bdr-go);
  color: #fff;
  cursor: pointer;
  transition: opacity 0.15s;
}

.bdr-tasks-filters__go-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.bdr-tasks-filters__go-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.bdr-tasks-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
}

.bdr-tasks-csv-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  padding: 7px 13px;
  border-radius: var(--bdr-radius-sm);
  border: 0.5px solid var(--bdr-border-2);
  background: var(--bdr-surface);
  color: var(--bdr-text-2);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}

.bdr-tasks-csv-btn:hover:not(:disabled) {
  border-color: var(--bdr-primary);
  color: var(--bdr-text);
}

.bdr-tasks-csv-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.bdr-verifier-column {
  min-width: 60px;
  white-space: nowrap;
}

.bdr-verifier-column .badge,
.bdr-verifier-column button {
  vertical-align: middle;
}
</style>
